import React, { useState, useEffect, useRef, Suspense } from "react";
import axios from "axios";

import { DataGrid } from '@mui/x-data-grid';
import Swal from 'sweetalert2';
import {Link, useParams} from 'react-router-dom';
import AutoComplete from '@mui/material/Autocomplete';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import TimePicker from 'react-time-picker';
import 'react-time-picker/dist/TimePicker.css';
import 'react-clock/dist/Clock.css';
import Box from '@mui/material/Box';
import Anatomy from "./Anatomy";
import { Canvas } from "@react-three/fiber";
import { OrbitControls } from "@react-three/drei";
import { Html } from '@react-three/drei';
import SpeechRecognition, {useSpeechRecognition} from 'react-speech-recognition';
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName} from '../Univ.js'

function ConsDetail(props){

  const {cons_id}=useParams();
  const {appt_id} = useParams();
  const [inputValue, setInputValue] = useState('');
  const [appointment, setAppointment] = useState([]);
  const [departments, setDepartments] = useState("");
  const [labview, setLabView] = useState([]);
  const [invview, setInvView] = useState([]);
  const [medview, setMedView] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [conData, setConData] = useState({});
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [medicalDate, setMedicalDate] = useState(new Date());
  const [points, setPoints] = useState([]);

  const [viewPharmData, setViewPharmData] = useState([]);
  const [drugitems, setdrugItems] = useState([]);
  const [drugrows, setdrugrows] = useState([{ id: '', product: '', dose:'', freq:'', remarks:''}]);
  const teethCount = 32;
  const teeth = Array.from({ length: teethCount }, (_, i) => i + 1);
  const [selectedTooth, setSelectedTooth] = useState([]);
  const [toothData, setToothData] = useState({});
  const [medical, setMedical] = useState({
    jaundice: false,
    highBP: false,
    heartDisease: false,
    bleedingDisorder: false,
    heamophilia: false,
    anaemia: false,
    fits: false,
    asthma: false,
    thyroid: false,
    diabetes: false,
    renal: false,
    pregnant: "",
  });

function handleToothClick(id) {
  setSelectedTooth(prev =>
    prev.includes(id) ? prev.filter(t => t !== id) : [...prev, id]
  );
}

function updateToothField(tooth, field, subfield, value) {
  setToothData(prev => ({
    ...prev,
    [tooth]: {
      ...(prev[tooth] || {}),
      [field]: {
        ...(prev[tooth]?.[field] || {}),
        [subfield]: value
      }
    }
  }));
}
const hardFields = ['Calculus', 'Stains', 'Dental Caries', 'Missing', 'Mobility'];
const softFields = ['Gingiva', 'Periodontium', 'Oral Mucosa'];

function toggleToothCheckbox(e, tooth) {
  const { name } = e.target; // field name
  const prev = toothData[tooth] || {};
  updateToothField(tooth, 'checkboxes', name, !prev?.checkboxes?.[name]);
}
function handleToothTextarea(e) {
  if (!selectedTooth) return;
  updateToothField(selectedTooth, e.target.name, e.target.value);
}

  function handleMedicalChange(e) {
    const { name, type, checked, value } = e.target;
    setMedical(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  }

// --- Ellipse Geometry ---
const cx = 410;   // center x
const cy = -10;   // center y (upper)
const rx = 170;   // horizontal radius
const ry = -150;  // negative so upper teeth curve upward

// --- Upper Teeth (U1 & U2) ---
const upperTeeth = Array.from({ length: 16 }, (_, i) => {
  const angle = (-160 + (i * 140) / 15) * (Math.PI / 180);
  const x = cx + rx * Math.cos(angle);
  const y = cy + ry * Math.sin(angle);

  let quadrant, qNum;
  if (i < 8) {
    quadrant = "U1";
    qNum = 8 - i;
  } else {
    quadrant = "U2";
    qNum = i - 7;
  }

  return { id: `${quadrant}Q${qNum}`, x: Math.round(x), y: Math.round(y) };
});

// --- Lower Teeth (L3 & L4) ---
const lowerTeeth = Array.from({ length: 16 }, (_, i) => {
  const cxLower = 410;    // same center x
  const cyLower = 450;    // 👈 lowered enough to be visible
  const rxLower = 170;
  const ryLower = -150;    // positive for downward curve

  // 🔥 key fix: use the same angle range, but flip the vertical direction
  const angle = (20 + (i * 140) / 15) * (Math.PI / 180);
  const x = cxLower + rxLower * Math.cos(angle);
  const y = cyLower + ryLower * Math.sin(angle); // 👈 positive ryLower keeps arc below

  let quadrant, qNum;
  if (i < 8) {
    quadrant = "L3";
    qNum = 8 - i;
  } else {
    quadrant = "L4";
    qNum = i - 7;
  }

  return { id: `${quadrant}Q${qNum}`, x: Math.round(x), y: Math.round(y) };
});

  const [registerFormData, setRegisterFormData] = useState({
        "weight":'',
        "height":'',
        "bmi":'',
        "tempr":'',
        "pulse":'',
        "bp":'',
        "spo2":'',
        "sugar":'',
        "allergy":'',
        "illness":'',
        "complaints":'',
        "diagnosis":'',
        "diet":'',
        "physio":'',
        "symptom":'',
        "examination":'',
        "review_date":'',
        "ip_status":'',
        "drug_status":'',
        "drug_id":'',
        "dose":'',
        "freq":'',
        "remarks":'',
        "status":'',
        "addedby":'',
        "ip_add":'',
    });
  const [labitems, setlabItems] = useState([]);
  const [labrows, setlabrows] = useState([{ ID: '', Subcat: '', Amount: '' }]);
  const [labtotal, setlabTotal] = useState(0);
  const [labsubtotal, setlabsubtotal] = useState(0);
  const [labdisPer, setlabdisPer] = useState(0);
  const [labdisAmount, setlabdisAmount] = useState(0);
  const [labData,setLabData]=useState({
        "appt_id":'',
        "pat":'',
        "cons":'',
        "lab_id":'',
        "ltest_id":'',
        "lab_test":'',
        "lab_amount":'',
        "lab_tot":'',
        "lab_disc":'',
        "lab_status":'',
        "addedby":'',
        "ip_add":'',
    });
  const [invitems, setinvItems] = useState([]);
  const [invrows, setinvRows] = useState([{ ID: '', Subcat: '', Amount: '' }]);
  const [invtotal, setinvTotal] = useState(0);
  const [invsubtotal, setinvsubTotal] = useState(0);
  const [invdisPer, setinvdisPer] = useState(0);
  const [invdisAmount, setinvdisAmount] = useState(0);
  const [invData,setinvData]=useState({
        "appt_id":'',
        "pat":'',
        "cons":'',
        "inv_id":'',
        "itest_id":'',
        "inv_test":'',
        "inv_amount":'',
        "inv_tot":'',
        "inv_disc":'',
        "inv_status":'',
        "addedby":'',
        "ip_add":'',
    });

  const [minitems, setminItems] = useState([]);
  const [minrows, setminRows] = useState([{ ID: '', Subcat: '', Amount: '' }]);
  const [mintotal, setminTotal] = useState(0);
  const [minsubtotal, setminsubTotal] = useState(0);
  const [mindisPer, setmindisPer] = useState(0);
  const [mindisAmount, setmindisAmount] = useState(0);
  const [minData,setminData]=useState({
        "appt_id":'',
        "pat":'',
        "cons":'',
        "min_id":'',
        "min_test":'',
        "min_amount":'',
        "min_tot":'',
        "min_disc":'',
        "min_status":'',
        "addedby":'',
        "ip_add":'',
    });
  const [medicalData,setMedicalData]=useState({
        "appt_id":'',
        "file_type":'',
        "files":'',
        "comments":'',
        "file_date":'',
        "status":'',
        "addedby":'',
        "ip_add":'',
    });
const parseSavedPoints = (coordinatesStr, textmapStr) => {
  const coordArr = coordinatesStr.split(',').map(c => {
    const [x, y, z] = c.split(':').map(Number);
    return [x, y, z];
  });

  const labels = textmapStr.split(',').map(l => l.trim());

  return coordArr.map((pos, i) => ({
    id: `${Date.now()}-${i}`,   // unique key
    position: pos,
    label: labels[i] || ''
  }));
};

const Marker = React.memo(function Marker({ point, onLabelChange }) {
  const [localLabel, setLocalLabel] = useState(point.label || '');

  // Keep local state synced if parent updates label
  useEffect(() => {
    setLocalLabel(point.label || '');
  }, [point.label]);

  return (
    <mesh position={point.position}>
      <sphereGeometry args={[0.05, 16, 16]} />
      <meshStandardMaterial color="red" />

      <Html distanceFactor={10} style={{ pointerEvents: 'auto' }}>
        <input
          type="text"
          placeholder="Enter label"
          value={localLabel}
          onChange={(e) => setLocalLabel(e.target.value)}
          onBlur={() => onLabelChange(point.id, localLabel)}
          onFocus={(e) => e.stopPropagation()}
          style={{
            padding: '2px',
            fontSize: '12px',
            width: '100px',
            outline: 'none'
          }}
        />
        <div style={{ fontSize: '10px', color: 'blue', marginTop: '4px' }}>
          x: {point.position[0].toFixed(2)},&nbsp;
          y: {point.position[1].toFixed(2)},&nbsp;
          z: {point.position[2].toFixed(2)}
        </div>
      </Html>
    </mesh>
  );
});

const handlePointClick = (position) => {
  const newPoint = {
    id: `${Date.now()}-${Math.random()}`, // always unique
    position: [position.x, position.y, position.z],
    label: ''
  };
  setPoints(prev => [...prev, newPoint]);
};

const handleLabelChange = (id, label) => {
  setPoints(prev =>
    prev.map(p => p.id === id ? { ...p, label } : p)
  );
};
    const handleSubmitD = async () => {
    const conId = conData[0].id;

  const formDataD = new FormData();

  // Prepare coordinates array
  const coordinates = points
    .map(p => `${p.position[0].toFixed(2)}:${p.position[1].toFixed(2)}:${p.position[2].toFixed(2)}`)
    .join(',');

  // Prepare textmap
  const textmap = points.map(p => p.label.trim()).join(',');

  formDataD.append('coordinates', coordinates);
  formDataD.append('textmap', textmap);
  formDataD.append('ip_add', ipAddress);
  formDataD.append('location', userLocation);

  console.log("Submitting:", { coordinates, textmap, conId });

  try {
    const response = await axios.put(baseUrl + 'edit-case/' + conId + '/', formDataD, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });

    if (response.status === 200 || response.status === 201) {
      Swal.fire({
        title: 'Details Updated.',
        icon: 'success',
        timer: 5000,
        showConfirmButton: false
      });
      setTimeout(() => {
        window.location.href = '/cons-detail/' + appt_id;
      }, 3000);
    }
  } catch (error) {
    console.error(error);
    Swal.fire('Error!', 'Failed to update', 'error');
  }
};


  const handleDateChange = (date) => {
  if (date) {
    const dateString = date.toISOString().slice(0,10);
    const dateObj = new Date(dateString);
    dateObj.setHours(0, 0, 0, 0);
    setSelectedDate(dateObj);
    }
    };
  const handleMedDateChange = (date) => {
  if (date) {
    const dateString = date.toISOString().slice(0,10);
    const dateObj = new Date(dateString);
    dateObj.setHours(0, 0, 0, 0);
    setMedicalDate(dateObj);
    }
    };

  useEffect(() => {
    fetchlviewData();
  }, []);

  function fetchlviewData() {
    axios.get(baseUrl + "view-lab/" + appt_id)
      .then(response => {
        setLabView(response.data);
      })
      .catch(error => {
        console.log(error);
      });
  }
  useEffect(() => {
    fetchiviewData();
  }, []);

  function fetchiviewData() {
    axios.get(baseUrl + "view-inv/" + appt_id)
      .then(response => {
        setInvView(response.data);
      })
      .catch(error => {
        console.log(error);
      });
  }

  useEffect(() => {
    fetchData();
  }, []);

  function fetchData() {
    axios.get(baseUrl + "view-appointment/" + appt_id)
      .then(response => {
        setAppointment(response.data);
        if (response.data.length > 0 && response.data[0].cons) {
           setDepartments(response.data[0].cons.department);
        }
      })
      .catch(error => {
        console.log(error);
      });
  }
  useEffect(() => {
    fetchPharmData();
  }, []);

  function fetchPharmData() {
    axios.get(`${baseUrl}indent-pharm-search/?dept=Pharmacy`)
      .then((pharmResponse) => {
        setdrugItems(pharmResponse.data);
      })
      .catch(error => {
        console.log(error);
      });
  }

  useEffect(() => {
  if (!appt_id) return;
  fetchConData();
}, [appt_id]);

const fetchConData = async () => {
  try {
    const response = await axios.get(
      `${baseUrl}view-consultform/${appt_id}`
    );

    const records = response?.data || [];

    // No consult data → reset safely
    if (records.length === 0) {
      console.log("No consult data found for this appointment");
      setConData([]);
      setPoints([]);
      return;
    }

    const data = records[0];
    setConData(records);

    // Process map data only if both exist
    if (data?.coordinates && data?.textmap) {
      setPoints(parseSavedPoints(data.coordinates, data.textmap));
    } else {
      setPoints([]);
    }

  } catch (error) {
    console.error("Failed to fetch consult data:", error);
    setConData([]);
    setPoints([]);
  }
};

  useEffect(() => {
    fetchmedData();
  }, []);

  function fetchmedData() {
    axios.get(baseUrl + "view-files/" + appt_id)
      .then(response => {
        setMedView(response.data);
      })
      .catch(error => {
        console.log(error);
      });
  }
  const inputHandler = (event) => {
  const { name, value } = event.target;

  // ✅ ALWAYS update registerFormData
  setRegisterFormData(prev => {
    const updated = { ...prev, [name]: value };

    if (name === "weight" || name === "height") {
      const weight = parseFloat(updated.weight);
      const height = parseFloat(updated.height);

      if (!isNaN(weight) && !isNaN(height) && height > 0) {
        updated.bmi = (weight / ((height / 100) ** 2)).toFixed(2);
      }
    }
    return updated;
  });

  // 🔁 ALSO update conData if it exists (edit mode)
  if (conData[0] != null) {
    const updatedConData = [{ ...conData[0], [name]: value }];

    if (name === "weight" || name === "height") {
      const weight = parseFloat(updatedConData[0].weight);
      const height = parseFloat(updatedConData[0].height);

      if (!isNaN(weight) && !isNaN(height) && height > 0) {
        updatedConData[0].bmi = (weight / ((height / 100) ** 2)).toFixed(2);
      }
    }
    setConData(updatedConData);
  }
};

  useEffect(() => {
    fetchLabData();
  }, []);

  function fetchLabData() {
    axios.get(`${baseUrl}lab-search/`)
      .then((labResponse) => {
        setlabItems(labResponse.data);

      })
      .catch(error => {
        console.log(error);
      });
  }

  useEffect(() => {
    fetchInvData();
  }, []);

  function fetchInvData() {
    axios.get(`${baseUrl}inv-search/`)
      .then((invResponse) => {
        setinvItems(invResponse.data);
      })
      .catch(error => {
        console.log(error);
      });
  }

  useEffect(() => {
    fetchMinData();
  }, []);

  function fetchMinData() {
    axios.get(`${baseUrl}min-search/`)
      .then((minResponse) => {
        setminItems(minResponse.data);
      })
      .catch(error => {
        console.log(error);
      });
  }

  const handleKeyDowndrug = (e, index) => {
      const newdrugrows = [...drugrows];
      switch (e.keyCode) {
        // Handle Shift key
        case 16:
          e.preventDefault();
          if (index === drugrows.length - 1) {
            newdrugrows.push({ id:'', product: '', dose:'', freq:'', remarks:''});
          }
          break;
        // Handle arrow up key
        case 38:
          e.preventDefault();
          if (newdrugrows[index].selectedItemdrug === 0) {
            newdrugrows[index].selectedItemdrug = drugitems.length - 1;
          } else {
            newdrugrows[index].selectedItemdrug--;
          }
          setdrugrows(newdrugrows);
          break;
        // Handle arrow down key
        case 40:
          e.preventDefault();
          if (newdrugrows[index].selectedItemdrug === drugitems.length - 1) {
            newdrugrows[index].selectedItemdrug = 0;
          } else {
            newdrugrows[index].selectedItemdrug++;
          }
          setdrugrows(newdrugrows);
          break;
        default:
          break;
      }
      setdrugrows(newdrugrows);
    };

  const handleSelectdrug = (val, index, id) => {
    if (val === undefined || val === null) {
    const newdrugrows = [...drugrows];
      newdrugrows[index] = { id: '', product: '', dose: '', freq: '', remarks:'' };
      setdrugrows(newdrugrows);
    } else {
       const selectedItemdrug = val;
    if (selectedItemdrug) {
    const newdrugrows = [...drugrows];
    newdrugrows[index] = {
      id: selectedItemdrug.id,
      product: selectedItemdrug.product.product,
      dose:'',
      freq:'',
      remarks:'',
    };
    setdrugrows(newdrugrows);
    }
    }
  };

  const handleAddRowdrug = () => {
    const newdrugrows = [...drugrows, { id:'', product: '', dose: '', freq:'', remarks:'' }];
    setdrugrows(newdrugrows);
  };

  const inputdrugRefs = useRef([]);

  useEffect(() => {
      inputdrugRefs.current[inputdrugRefs.current.length - 1]?.focus();
  }, [drugrows.length]);

  const handleDeleteRowdrug = (index) => {
    const newdrugrows = [...drugrows];
    newdrugrows.splice(index, 1);
    setdrugrows(newdrugrows);
  };

const handledrugChange = (event, index) => {
  const { name, value } = event.target;
  const newdrugrows = [...drugrows];
  newdrugrows[index][name] = value;
  setdrugrows(newdrugrows);
};

  const handleKeyDownlab = (e, index) => {
      const newlabrows = [...labrows];
      switch (e.keyCode) {
        // Handle Shift key
        case 16:
          e.preventDefault();
          if (index === labrows.length - 1) {
            newlabrows.push({ id:'', subcat: '', amount: '' });
          }
          break;
        // Handle arrow up key
        case 38:
          e.preventDefault();
          if (newlabrows[index].selectedItemlab === 0) {
            newlabrows[index].selectedItemlab = labitems.length - 1;
          } else {
            newlabrows[index].selectedItemlab--;
          }
          setlabrows(newlabrows);
          break;
        // Handle arrow down key
        case 40:
          e.preventDefault();
          if (newlabrows[index].selectedItemlab === labitems.length - 1) {
            newlabrows[index].selectedItemlab = 0;
          } else {
            newlabrows[index].selectedItemlab++;
          }
          setlabrows(newlabrows);
          break;
        default:
          break;
      }
      setlabrows(newlabrows);
    };

  const handleSelectlab = (val, index) => {
  if (val === undefined || val === null) {
   const newlabrows = [...labrows];
      newlabrows[index] = { id: '', subcat: '', amount: '' };
      setlabrows(newlabrows);
    } else {
    const selectedItemlab = labitems.find(item => item.subcat === val);
    if (selectedItemlab) {
    const newlabrows = [...labrows];
    newlabrows[index] = {
      id: selectedItemlab.id,
      subcat: selectedItemlab.subcat,
      amount: selectedItemlab.amount
    };
    setlabrows(newlabrows);
    }
    }
  };


  const handleAmountChangelab = (e, index) => {
    const newlabrows = [...labrows];
    newlabrows[index].labamount = parseFloat(e.target.value) || 0;
    setlabrows(newlabrows);
  };

  const handleAddRowlab = () => {
    const newlabrows = [...labrows, { id:'', subcat: '', amount: '' }];
    setlabrows(newlabrows);
  };

  const inputlabRefs = useRef([]);

  useEffect(() => {
      inputlabRefs.current[inputlabRefs.current.length - 1]?.focus();
  }, [labrows]);

  const handleDeleteRowlab = (index) => {
    const newlabrows = [...labrows];
    newlabrows.splice(index, 1);
    setlabrows(newlabrows);
  };


  const handlelabdisPerChange = (e) => {
   const newlabdisPer = parseFloat(e.target.value) || 0;
   setlabdisPer(newlabdisPer);
  };


  useEffect(() => {
    let labsubtotal = 0;
    let labdisAmount = 0;

    let newlabTotal = 0;
    for (let i = 0; i < labrows.length; i++) {
      const row = labrows[i];
      labsubtotal += row.amount;
      labdisAmount = labsubtotal * ( parseFloat(labdisPer) /100 );
      newlabTotal = labsubtotal - labdisAmount;
    }
    setlabsubtotal(labsubtotal);
    setlabdisPer(labdisPer);
    setlabdisAmount(labdisAmount);
    setlabTotal(newlabTotal);
  }, [labrows, labdisPer]);

  const handlelabChange = (event) => {
    const { name, value } = event.target;
    setLabData(prevState => ({ ...prevState, [name]: value }));
  };

    const handleKeyDowninv = (e, index) => {
      const newinvRows = [...invrows];
      switch (e.keyCode) {
        // Handle Shift key
        case 16:
          e.preventDefault();
          if (index === invrows.length - 1) {
            newinvRows.push({ id:'', components: '', amount: '' });
          }
          break;
        // Handle arrow up key
        case 38:
          e.preventDefault();
          if (newinvRows[index].selectedIteminv === 0) {
            newinvRows[index].selectedIteminv = invitems.length - 1;
          } else {
            newinvRows[index].selectedIteminv--;
          }
          setinvRows(newinvRows);
          break;
        // Handle arrow down key
        case 40:
          e.preventDefault();
          if (newinvRows[index].selectedIteminv === invitems.length - 1) {
            newinvRows[index].selectedIteminv = 0;
          } else {
            newinvRows[index].selectedIteminv++;
          }
          setinvRows(newinvRows);
          break;
        default:
          break;
      }
      setinvRows(newinvRows);
    };

  const handleSelectinv = (val, index) => {
  if (val === undefined || val === null) {
  const newinvRows = [...invrows];
      newinvRows[index] = { id: '', components: '', amount: '' };
      setinvRows(newinvRows);
    } else {
    const selectedIteminv = invitems.find(item => item.components === val);
    if (selectedIteminv) {
    const newinvRows = [...invrows];
    newinvRows[index] = {
      id: selectedIteminv.id,
      components: selectedIteminv.components,
      amount: selectedIteminv.amount
    };
    setinvRows(newinvRows);
    }
    }
  };


  const handleAmountChangeinv = (e, index) => {
    const newinvRows = [...invrows];
    newinvRows[index].invamount = parseFloat(e.target.value) || 0;
    setinvRows(newinvRows);
  };
 const handleAddRowinv = () => {
        const newinvRows = [...invrows, { id: '', components: '', amount: '' }];
        setinvRows(newinvRows);
      };
  const inputinvRefs = useRef([]);

  useEffect(() => {
      inputinvRefs.current[inputinvRefs.current.length - 1]?.focus();
  }, [invrows]);

  const handleDeleteRowinv = (index) => {
    const newinvRows = [...invrows];
    newinvRows.splice(index, 1);
    setinvRows(newinvRows);
  };


  const handleinvDisPerChange = (e) => {
   const newinvdisPer = parseFloat(e.target.value) || 0;
   setinvdisPer(newinvdisPer);
  };


  useEffect(() => {
    let invsubTotal = 0;
    let invdisAmount = 0;

    let newinvTotal = 0;
    for (let i = 0; i < invrows.length; i++) {
      const row = invrows[i];
      invsubTotal += row.amount;
      invdisAmount = invsubTotal * ( parseFloat(invdisPer) /100 );
      newinvTotal = invsubTotal - invdisAmount;
    }
    setinvsubTotal(invsubTotal);
    setinvdisPer(invdisPer);
    setinvdisAmount(invdisAmount);
    setinvTotal(newinvTotal);
  }, [invrows, invdisPer]);


  const handleinvChange = (event) => {
    const { name, value } = event.target;
    setinvData(prevState => ({ ...prevState, [name]: value }));
  };
  const handleKeyDownmin = (e, index) => {
      const newminRows = [...minrows];
      switch (e.keyCode) {
        // Handle Shift key
        case 16:
          e.preventDefault();
          if (index === minrows.length - 1) {
            newminRows.push({ id:'', comp: '', amount: '' });
          }
          break;
        // Handle arrow up key
        case 38:
          e.preventDefault();
          if (newminRows[index].selectedItemmin === 0) {
            newminRows[index].selectedItemmin = minitems.length - 1;
          } else {
            newminRows[index].selectedItemmin--;
          }
          setminRows(newminRows);
          break;
        // Handle arrow down key
        case 40:
          e.preventDefault();
          if (newminRows[index].selectedItemmin === minitems.length - 1) {
            newminRows[index].selectedItemmin = 0;
          } else {
            newminRows[index].selectedItemmin++;
          }
          setminRows(newminRows);
          break;
        default:
          break;
      }
      setminRows(newminRows);
    };

  const handleSelectmin = (val, index) => {
     if (val === undefined || val === null) {
     const newminRows = [...minrows];
     newminRows[index] = { id: '', comp: '', amount: '' };
      setminRows(newminRows);
     } else {
    const selectedItemmin = minitems.find(item => item.comp === val);
    if (selectedItemmin) {
    const newminRows = [...minrows];
    newminRows[index] = {
      id: selectedItemmin.id,
      comp: selectedItemmin.comp,
      amount: selectedItemmin.amount
    };
    setminRows(newminRows);
    }
  }
  };


  const handleAmountChangemin = (e, index) => {
    const newminRows = [...minrows];
    newminRows[index].minamount = parseFloat(e.target.value) || 0;
    setminRows(newminRows);
  };
  const handleAddRowmin = () => {
        const newminRows = [...minrows, { id: '', comp: '', amount: '' }];
        setminRows(newminRows);
      };

  const inputminRefs = useRef([]);

  useEffect(() => {
      inputminRefs.current[inputminRefs.current.length - 1]?.focus();
  }, [minrows]);

  const handleDeleteRowmin = (index) => {
    const newminRows = [...minrows];
    newminRows.splice(index, 1);
    setminRows(newminRows);
  };


  const handleminDisPerChange = (e) => {
   const newmindisPer = parseFloat(e.target.value) || 0;
   setmindisPer(newmindisPer);
  };


  useEffect(() => {
    let minsubTotal = 0;
    let mindisAmount = 0;

    let newminTotal = 0;
    for (let i = 0; i < minrows.length; i++) {
      const row = minrows[i];
      minsubTotal += row.amount;
      mindisAmount = minsubTotal * ( parseFloat(mindisPer) /100 );
      newminTotal = minsubTotal - mindisAmount;
    }
    setminsubTotal(minsubTotal);
    setmindisPer(mindisPer);
    setmindisAmount(mindisAmount);
    setminTotal(newminTotal);
  }, [minrows, mindisPer]);


  const handleminChange = (event) => {
    const { name, value } = event.target;
    setminData(prevState => ({ ...prevState, [name]: value }));
  };
  const [ipStatus, setIpStatus] = useState(0);
  const handleCheckboxChange = (event) => {
    const value = event.target.checked ? 1 : 0;
    setIpStatus(value);
  };
  const handleMedChange = (event) => {
        setMedicalData({
            ...medicalData,
            [event.target.name]:event.target.value
        });
    }
  const handleFileChange = (event) => {
        setMedicalData({
            ...medicalData,
            [event.target.name]:event.target.files[0]
        });
    }
    const handleFormSubmit = (e) => {
     e.preventDefault();
        const formData = new FormData();
        formData.append('appt_id', appointment[0].appt_id);
        formData.append('appt_date', appointment[0].appt_date);
        formData.append('type', appointment[0].type);
        formData.append('addedby', appointment[0].addedby);
        formData.append('status', '3');
        formData.append('ip_add', ipAddress);
          formData.append('location', userLocation);
        axios.put(baseUrl+'update-appt/'+appt_id+'/', formData)
        .then((response) => {
        if(response.status==200 || response.status==201){
                Swal.fire({
                  title: 'Completed.',
                  icon: 'success',
                  timer: 5000,
                  showConfirmButton: false
                });

                setTimeout(() => {
                  window.location.href = '/op-case/'+ appt_id;
                }, 3000);
        }
        })
     };

const submitHandler = (e) => {
  e.preventDefault();
  const formData = new FormData();

  const apptId = appointment.map(row => row.id);
  const patId = appointment.map(row => row.pat.id);
  const conId = conData.length > 0 ? conData[0].id : null;

  /* =====================================================
     SAFE DRUG HANDLING (PREVENT NULL OVERWRITE)
  ====================================================== */

  let drugIds = '';
  let drugDose = '';
  let drugFreq = '';
  let drugRemarks = '';

  if (drugrows && drugrows.length > 0) {
    drugIds = drugrows.map(row => row.id).join(',');
    drugDose = drugrows.map(row => row.dose).join(',');
    drugFreq = drugrows.map(row => row.freq).join(',');
    drugRemarks = drugrows.map(row => row.remarks).join(',');
  } else if (conData.length > 0) {
    // fallback to existing drugs if not modified
    drugIds = conData[0].drug_id || '';
    drugDose = conData[0].dose || '';
    drugFreq = conData[0].freq || '';
    drugRemarks = conData[0].remarks || '';
  }

  /* =====================================================
     DENTAL SECTION
  ====================================================== */

  let teethNotesString = '';
  let chiefComplaints = '';
  let medHistoryVals = '';
  let otherDrugs = '';
  let history = '';
  let pregnant = '';
  let tsuggVal = '';
  let tadviseVal = '';

  if (departments === "DENTAL") {

    teethNotesString = (selectedTooth.length > 0
      ? selectedTooth.map(id => {
          const tooth = toothData[id] || {};
          const hardNotes = hardFields.map(f => `${f}:${tooth?.hard?.[f] || ''}`).join(',');
          const softNotes = softFields.map(f => `${f}:${tooth?.soft?.[f] || ''}`).join(',');
          return `${id}:${hardNotes}${softFields.length ? ',' + softNotes : ''}`;
        }).join(';')
      : (conData.length > 0 ? conData[0].teeth_notes : '')
    );

    chiefComplaints = ['pain','badBreath','malalign','decay','sensitivity','replacement']
      .map(c => document.querySelector(`input[name="${c}"]`)?.checked ? c : '')
      .filter(Boolean)
      .join(',');

    const medHistoryFields = ['jaundice','highBP','heartDisease','bleedingDisorder','heamophilia','anaemia','fits','asthma','thyroid','diabetes','renal'];

    medHistoryVals = medHistoryFields
      .map(m => document.querySelector(`input[name="${m}"]`)?.checked ? m : '')
      .filter(Boolean)
      .join(',') || (conData.length > 0 ? conData[0].med_history : '');

    otherDrugs = medical.otherdrugs || (conData.length > 0 ? conData[0].otherdrugs : '');
    history = medical.history || (conData.length > 0 ? conData[0].history : '');
    pregnant = medical.pregnant || (conData.length > 0 ? conData[0].ispregnant : '');

    tsuggVal = transcripts.tsugg || registerFormData.tsugg || (conData.length > 0 ? conData[0].tsugg : '');
    tadviseVal = transcripts.tadvise || registerFormData.tadvise || (conData.length > 0 ? conData[0].tadvise : '');
  }

  /* =====================================================
     SAFE MERGE FOR ALL FIELDS
  ====================================================== */

  const finalData = {
    weight: registerFormData.weight || conData?.[0]?.weight,
    height: registerFormData.height || conData?.[0]?.height,
    bmi: registerFormData.bmi || conData?.[0]?.bmi,
    tempr: registerFormData.tempr || conData?.[0]?.tempr,
    pulse: registerFormData.pulse || conData?.[0]?.pulse,
    bp: registerFormData.bp || conData?.[0]?.bp,
    spo2: registerFormData.spo2 || conData?.[0]?.spo2,
    sugar: registerFormData.sugar || conData?.[0]?.sugar,

    allergy: transcripts.allergy || registerFormData.allergy || conData?.[0]?.allergy,
    illness: transcripts.illness || registerFormData.illness || conData?.[0]?.illness,
    complaints: transcripts.complaints || registerFormData.complaints || conData?.[0]?.complaints,
    diagnosis: transcripts.diagnosis || registerFormData.diagnosis || conData?.[0]?.diagnosis,
    diet: transcripts.diet || registerFormData.diet || conData?.[0]?.diet,
    physio: transcripts.physio || registerFormData.physio || conData?.[0]?.physio,
    examination: transcripts.examination || registerFormData.examination || conData?.[0]?.examination,
  };

  const finalSymptom =
    selectedSymptom === "OTHER"
      ? registerFormData.other_symptom?.trim() || conData?.[0]?.symptom
      : selectedSymptom || conData?.[0]?.symptom;

  /* =====================================================
     COMMON APPEND
  ====================================================== */

  formData.append('appt', apptId);
  formData.append('pat', patId);
  formData.append('weight', finalData.weight);
  formData.append('height', finalData.height);
  formData.append('bmi', finalData.bmi);
  formData.append('tempr', finalData.tempr);
  formData.append('pulse', finalData.pulse);
  formData.append('bp', finalData.bp);
  formData.append('spo2', finalData.spo2);
  formData.append('sugar', finalData.sugar);
  formData.append('allergy', finalData.allergy);
  formData.append('illness', finalData.illness);
  formData.append('complaints', finalData.complaints);
  formData.append('diagnosis', finalData.diagnosis);
  formData.append('diet', finalData.diet);
  formData.append('physio', finalData.physio);
  formData.append('symptom', finalSymptom);
  formData.append('examination', finalData.examination);
  formData.append('review_date', selectedDate.toISOString().slice(0,10));
  formData.append('drug_status', 1);

  if (drugIds !== '') {
    formData.append('drug_id', drugIds);
    formData.append('dose', drugDose);
    formData.append('freq', drugFreq);
    formData.append('remarks', drugRemarks);
  }

  if (departments === "DENTAL") {
    formData.append('teeth_notes', teethNotesString);
    formData.append('chief_complaints', chiefComplaints);
    formData.append('med_history', medHistoryVals);
    formData.append('otherdrugs', otherDrugs);
    formData.append('history', history);
    formData.append('ispregnant', pregnant);
    formData.append('tsugg', tsuggVal);
    formData.append('tadvise', tadviseVal);
  }

  formData.append('ip_status', ipStatus);
  formData.append('ip_add', ipAddress);
  formData.append('location', userLocation);

  /* =====================================================
     UPDATE OR CREATE
  ====================================================== */

  if (conId) {

    axios.put(baseUrl + 'edit-case/' + conId + '/', formData)
      .then(response => {
        if (response.status === 200 || response.status === 201) {
          Swal.fire({
            title: 'Details Updated.',
            icon: 'success',
            timer: 4000,
            showConfirmButton: false
          });
          setTimeout(() => {
            window.location.href = '/cons-detail/' + appt_id;
          }, 3000);
        }
      })
      .catch(error => {
        console.log(error);
        Swal.fire('Error!', 'Failed to update', 'error');
      });

  } else {

    formData.append('status', '1');
    formData.append('addedby', userName);

    axios.post(baseUrl + 'consultform/', formData)
      .then(response => {
        if (response.status === 200 || response.status === 201) {
          Swal.fire({
            title: 'Details has been added.',
            icon: 'success',
            timer: 4000,
            showConfirmButton: false
          });
          setTimeout(() => {
            window.location.href = '/cons-detail/' + appt_id;
          }, 3000);
        }
      })
      .catch(error => {
        console.log(error);
        Swal.fire('Error!', 'Failed to Add. Please try again later.', 'error');
      });
  }
};
  const formSubmitlab = (e) => {
      e.preventDefault();
          axios.post(`${baseUrl}get_appt_lab_number/`)
          .then(response => {
          const appt_lab = response.data.value;
          const _formData = new FormData();
          _formData.append('appt_id', appt_lab);
          _formData.append('pat', appointment.map(row => row.pat.id));
          _formData.append('cons', appointment.map(row => row.cons.id));
          _formData.append('lab_id', appt_lab);
          _formData.append('ltest_id', labrows.map(row => row.id).join(','));
          _formData.append('lab_test', labrows.map(row => row.subcat).join(','));
          _formData.append('lab_amount', labrows.map(row => row.amount).join(','));
          _formData.append('lab_tot', labtotal);
          _formData.append('lab_disc', labdisAmount.toString());
          _formData.append('lab_status', '1');
          _formData.append('addedby', userName);
          _formData.append('ip_add', ipAddress);
          _formData.append('location', userLocation);

          axios.post(`${baseUrl}lab-create/`, _formData)
            .then(response => {
              if(response.status==200 || response.status==201){
                Swal.fire({
                  title: 'Lab entry has been added.',
                  icon: 'success',
                  timer: 5000,
                  showConfirmButton: false
                });
                setLabData({
                  appt_id: '',
                  pat: '',
                  cons: '',
                  lab_id: '',
                  ltest_id: '',
                  lab_test: '',
                  lab_amount: '',
                  lab_tot: '',
                  lab_disc: '',
                  lab_status: '',
                  addedby: '',
                  ip_add: '',
                });
                setlabrows([{ id: '', subcat: '', amount: '' }]);
                setlabTotal(0);
                setlabsubtotal(0);
                setlabdisPer(0);
                setlabdisAmount('');
                setTimeout(() => {
                  window.location.href = '/cons-detail/'+appt_id;
                }, 3000);
              }
            })
            .catch(error => {
              console.log(error);
              Swal.fire(
                'Error!',
                'Failed to add lab entry. Please try again later.',
                'error'
              );
            });
        })
        .catch(error => {
          console.log(error);
          Swal.fire(
            'Error!',
            'Failed to generate unique value. Please try again later.',
            'error'
          );
        });
  };

    const formSubmitinv = (e) => {
      e.preventDefault();
          axios.post(`${baseUrl}get_appt_inv_number/`)
          .then(response => {
          const appt_inv = response.data.value;
          const _formData = new FormData();
          _formData.append('appt_id', appt_inv);
          _formData.append('pat', appointment.map(row => row.pat.id));
          _formData.append('cons', appointment.map(row => row.cons.id));
          _formData.append('inv_id', appointment.map(row => row.id));
          _formData.append('itest_id', invrows.map(row => row.id).join(','));
          _formData.append('inv_test', invrows.map(row => row.components).join(','));
          _formData.append('inv_amount', invrows.map(row => row.amount).join(','));
          _formData.append('inv_tot', invtotal);
          _formData.append('inv_disc', invdisAmount.toString());
          _formData.append('inv_status', '1');
          _formData.append('addedby', userName);
          _formData.append('ip_add', ipAddress);
          _formData.append('location', userLocation);

          axios.post(`${baseUrl}inv-create/`, _formData)
            .then(response => {
              if(response.status==200 || response.status==201){
                Swal.fire({
                  title: 'inv entry has been added.',
                  icon: 'success',
                  timer: 5000,
                  showConfirmButton: false
                });
                setinvData({
                  appt_id: '',
                  pat: '',
                  cons: '',
                  inv_id: '',
                  itest_id: '',
                  inv_test: '',
                  inv_amount: '',
                  inv_tot: '',
                  inv_disc: '',
                  inv_status: '',
                  addedby: '',
                  ip_add: '',
                });
                setinvRows([{ id: '', components: '', amount: '' }]);
                setinvTotal(0);
                setinvsubTotal(0);
                setinvdisPer(0);
                setinvdisAmount('');
                setTimeout(() => {
                  window.location.href = '/cons-detail/'+appt_id;
                }, 3000);
              }
            })
            .catch(error => {
              console.log(error);
              Swal.fire(
                'Error!',
                'Failed to add inv entry. Please try again later.',
                'error'
              );
            });
        })
        .catch(error => {
          console.log(error);
          Swal.fire(
            'Error!',
            'Failed to generate unique value. Please try again later.',
            'error'
          );
        });
  };
  const formSubmitmin = (e) => {
      e.preventDefault();
          axios.post(`${baseUrl}get_appt_min_number/`)
          .then(response => {
          const appt_min = response.data.value;
          const _formData = new FormData();
          _formData.append('appt_id', appt_min);
          _formData.append('pat', appointment.map(row => row.pat.id));
          _formData.append('cons', appointment.map(row => row.cons.id));
          _formData.append('min_id', minrows.map(row => row.id).join(','));
          _formData.append('min_test', minrows.map(row => row.comp).join(','));
          _formData.append('min_amount', minrows.map(row => row.amount).join(','));
          _formData.append('min_tot', mintotal);
          _formData.append('min_disc', mindisAmount.toString());
          _formData.append('min_status', '1');
          _formData.append('addedby', userName);
          _formData.append('ip_add', ipAddress);
          _formData.append('location', userLocation);

          axios.post(`${baseUrl}min-create/`, _formData)
            .then(response => {
              if(response.status==200 || response.status==201){
                Swal.fire({
                  title: 'min entry has been added.',
                  icon: 'success',
                  timer: 5000,
                  showConfirmButton: false
                });
                setminData({
                  appt_id: '',
                  pat: '',
                  cons: '',
                  min_id: '',

                  min_test: '',
                  min_amount: '',
                  min_tot: '',
                  min_disc: '',
                  min_status: '',
                  addedby: '',
                  ip_add: '',
                });
                setminRows([{ id: '', comp: '', amount: '' }]);
                setminTotal(0);
                setminsubTotal(0);
                setmindisPer(0);
                setmindisAmount('');
                setTimeout(() => {
                  window.location.href = '/cons-detail/'+ appt_id;
                }, 3000);
              }
            })
            .catch(error => {
              console.log(error);
              Swal.fire(
                'Error!',
                'Failed to add min entry. Please try again later.',
                'error'
              );
            });
        })
        .catch(error => {
          console.log(error);
          Swal.fire(
            'Error!',
            'Failed to generate unique value. Please try again later.',
            'error'
          );
        });
  };
  const formSubmitmed = (e) => {
      e.preventDefault();
          const _formData = new FormData();
          const file_type = document.getElementById("ftype").value;
          const apptId = appointment.map(row => row.id);
          _formData.append('appt', apptId);
          _formData.append('file_type', file_type);
          if(medicalData.f_files!==''){
            _formData.append('files', medicalData.f_files, medicalData.f_files.name);
          }
          _formData.append('comments', medicalData.comments);
          _formData.append('file_date', medicalDate.toISOString().slice(0,10));
          _formData.append('status', '1');
          _formData.append('addedby', userName);
          _formData.append('ip_add', ipAddress);
          _formData.append('location', userLocation);

          axios.post(`${baseUrl}op-file-create/`, _formData)
            .then(response => {
              if(response.status==200 || response.status==201){
                Swal.fire({
                  title: 'File has been added.',
                  icon: 'success',
                  timer: 5000,
                  showConfirmButton: false
                });
                setMedicalData({
                  appt_id: '',
                  file_type: '',
                  files: '',
                  comments: '',
                  file_date: '',
                  status: '',
                  addedby: '',
                  ip_add: '',
                });
                setTimeout(() => {
                  window.location.href = '/cons-detail/'+ appt_id;
                }, 3000);
              }
            })
            .catch(error => {
              console.log(error);
              Swal.fire(
                'Error!',
                'Failed to add min entry. Please try again later.',
                'error'
              );
            });
  };
   const handleDelete = (id) => {
        Swal.fire({
            title: 'Confirm',
            text: 'Are you Sure you want to delete this',
            icon: 'info',
            confirmButtonText: 'Continue',
            showCancelButton: true
        }).then((result)=>{
            if(result.isConfirmed){
               try{
                   axios.delete(baseUrl+'delete-files/'+id)
                   .then(function (response) {
                      Swal.fire('success', 'Data has been Deleted');
                      window.location.reload();
                    });
               }catch(error){
                    Swal.fire('error', 'Data has not been deleted');
               }
            }else{
                  Swal.fire('error', 'Data has not been deleted');
            }

        })
    }

useEffect(() => {
  if (Array.isArray(conData)) {
    const dd = conData.map(row => row.drug_id);
    if (dd !== null) {
      function fetchPharmData1() {
        const ipIds = conData.map(row => row.drug_id?.split(',').map(item => item.trim()));
        ipIds.forEach(ipId => {
          try {
            ipId.forEach(id => {
              axios.get(baseUrl + 'update-indent-use/' + id + '/')
                .then(function (response) {
                  const data = Object.assign({}, response.data);
                  setViewPharmData(prevData => [...prevData, data]);
                })
                .catch(function (error) {
                  console.log(error);
                });
            });
          } catch (error) {
            console.log(error);
          }
        });
      }

      fetchPharmData1();
    }
  }
}, [conData]);
const [language, setLanguage] = useState('');
const [activeField, setActiveField] = useState(null); // which textarea is currently listening
const [transcripts, setTranscripts] = useState({
  allergy: '',
  illness: '',
  complaints: '',
  diagnosis: '',
  diet: '',
  physio: '',
  examination: ''
});
const { transcript, resetTranscript } = useSpeechRecognition({ continuous: true });

useEffect(() => {
  if (!activeField) return;

  setTranscripts(prev => ({
    ...prev,
    [activeField]: transcript
  }));
}, [transcript, activeField]);

const startListeningForField = (fieldName) => {
  setActiveField(fieldName);    // mark which field is active
  resetTranscript();            // clear previous transcript
  SpeechRecognition.startListening({ continuous: true, language });
};
const stopListening = () => {
  SpeechRecognition.stopListening();
  setActiveField(null);  // no active field
};


  const languages = [
  {
    no: "16",
    name: "English",
    native: "English",
    code: "en",
  },
  {
    no: "1",
    name: "Afrikaans",
    native: "Afrikaans",
    code: "af",
  },
  {
    no: "2",
    name: "Albanian",
    native: "Shqip",
    code: "sq",
  },
  {
    no: "3",
    name: "Arabic",
    native: "عربي",
    code: "ar",
  },
  {
    no: "4",
    name: "Armenian",
    native: "Հայերէն",
    code: "hy",
  },
  {
    no: "5",
    name: "Azerbaijani",
    native: "آذربایجان دیلی",
    code: "az",
  },
  {
    no: "6",
    name: "Basque",
    native: "Euskara",
    code: "eu",
  },
  {
    no: "7",
    name: "Belarusian",
    native: "Беларуская",
    code: "be",
  },
  {
    no: "8",
    name: "Bulgarian",
    native: "Български",
    code: "bg",
  },
  {
    no: "9",
    name: "Catalan",
    native: "Català",
    code: "ca",
  },
  {
    no: "10",
    name: "Chinese (Simplified)",
    native: "中文简体",
    code: "zh-CN",
  },
  {
    no: "11",
    name: "Chinese (Traditional)",
    native: "中文繁體",
    code: "zh-TW",
  },
  {
    no: "12",
    name: "Croatian",
    native: "Hrvatski",
    code: "hr",
  },
  {
    no: "13",
    name: "Czech",
    native: "Čeština",
    code: "cs",
  },
  {
    no: "14",
    name: "Danish",
    native: "Dansk",
    code: "da",
  },
  {
    no: "15",
    name: "Dutch",
    native: "Nederlands",
    code: "nl",
  },
  {
    no: "17",
    name: "Estonian",
    native: "Eesti keel",
    code: "et",
  },
  {
    no: "18",
    name: "Filipino",
    native: "Filipino",
    code: "tl",
  },
  {
    no: "19",
    name: "Finnish",
    native: "Suomi",
    code: "fi",
  },
  {
    no: "20",
    name: "French",
    native: "Français",
    code: "fr",
  },
  {
    no: "21",
    name: "Galician",
    native: "Galego",
    code: "gl",
  },
  {
    no: "22",
    name: "Georgian",
    native: "ქართული",
    code: "ka",
  },
  {
    no: "23",
    name: "German",
    native: "Deutsch",
    code: "de",
  },
  {
    no: "24",
    name: "Greek",
    native: "Ελληνικά",
    code: "el",
  },
  {
    no: "25",
    name: "Haitian Creole",
    native: "Kreyòl ayisyen",
    code: "ht",
  },
  {
    no: "26",
    name: "Hebrew",
    native: "עברית",
    code: "iw",
  },
  {
    no: "27",
    name: "Hindi",
    native: "हिन्दी",
    code: "hi",
  },
  {
    no: "28",
    name: "Hungarian",
    native: "Magyar",
    code: "hu",
  },
  {
    no: "29",
    name: "Icelandic",
    native: "Íslenska",
    code: "is",
  },
  {
    no: "30",
    name: "Indonesian",
    native: "Bahasa Indonesia",
    code: "id",
  },
  {
    no: "31",
    name: "Irish",
    native: "Gaeilge",
    code: "ga",
  },
  {
    no: "32",
    name: "Italian",
    native: "Italiano",
    code: "it",
  },
  {
    no: "33",
    name: "Japanese",
    native: "日本語",
    code: "ja",
  },
  {
    no: "34",
    name: "Korean",
    native: "한국어",
    code: "ko",
  },
  {
    no: "35",
    name: "Latvian",
    native: "Latviešu",
    code: "lv",
  },
  {
    no: "36",
    name: "Lithuanian",
    native: "Lietuvių kalba",
    code: "lt",
  },
  {
    no: "37",
    name: "Macedonian",
    native: "Македонски",
    code: "mk",
  },
  {
    no: "38",
    name: "Malay",
    native: "Malay",
    code: "ms",
  },
  {
    no: "39",
    name: "Maltese",
    native: "Malti",
    code: "mt",
  },
  {
    no: "40",
    name: "Norwegian",
    native: "Norsk",
    code: "no",
  },
  {
    no: "41",
    name: "Persian",
    native: "فارسی",
    code: "fa",
  },
  {
    no: "42",
    name: "Polish",
    native: "Polski",
    code: "pl",
  },
  {
    no: "43",
    name: "Portuguese",
    native: "Português",
    code: "pt",
  },
  {
    no: "44",
    name: "Romanian",
    native: "Română",
    code: "ro",
  },
  {
    no: "45",
    name: "Russian",
    native: "Русский",
    code: "ru",
  },
  {
    no: "46",
    name: "Serbian",
    native: "Српски",
    code: "sr",
  },
  {
    no: "47",
    name: "Slovak",
    native: "Slovenčina",
    code: "sk",
  },
  {
    no: "48",
    name: "Slovenian",
    native: "Slovensko",
    code: "sl",
  },
  {
    no: "49",
    name: "Spanish",
    native: "Español",
    code: "es",
  },
  {
    no: "50",
    name: "Swahili",
    native: "Kiswahili",
    code: "sw",
  },
  {
    no: "51",
    name: "Swedish",
    native: "Svenska",
    code: "sv",
  },
  {
    no: "52",
    name: "Thai",
    native: "ไทย",
    code: "th",
  },
  {
    no: "53",
    name: "Turkish",
    native: "Türkçe",
    code: "tr",
  },
  {
    no: "54",
    name: "Ukrainian",
    native: "Українська",
    code: "uk",
  },
  {
    no: "55",
    name: "Urdu",
    native: "اردو",
    code: "ur",
  },
  {
    no: "56",
    name: "Vietnamese",
    native: "Tiếng Việt",
    code: "vi",
  },
  {
    no: "57",
    name: "Welsh",
    native: "Cymraeg",
    code: "cy",
  },
  {
    no: "58",
    name: "Yiddish",
    native: "ייִדיש",
    code: "yi",
  },
];
const symptomOptions = [
  "Headache","Fever","Running Nose","Sore Throat","Sneezing","Cough","Sputum",
  "Wheeze","Dyspnea","PND","Pedal Oedema","Anasarca","Puffy Face","Swelling",
  "Neck Swelling","Groin","Pain","Itching","Urticaria","Weakness","Vertigo",
  "Unsteadiness","Chest Pain","Burning Micturition","Frequency Of Urine",
  "Urgency","Diarrhea","Constipation","Bleeding PR","Epigastric Pain",
  "Loin Pain","Loin Pain Radiating to Rt Groin","Loin Pain Radiating to Lt Groin",
  "LBA","LBA Radiating to Rt Thigh","LBA Radiating to Lt Thigh","Neck Pain",
  "Neck Pain Radiating to Rt Upper Limb","Neck Pain Radiating to Left Upper Limb"
];
const selectedSymptom = (() => {
  const dbSymptom =
    conData?.length > 0
      ? conData?.[0]?.symptom
      : registerFormData.symptom;

  return symptomOptions.includes(dbSymptom)
    ? dbSymptom
    : "OTHER";
})();

    return (
    <section className="container mt-4">
     <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <i className="fa-solid fa-stethoscope" aria-hidden="true" style={{ color: 'red' }}></i>
      Appointment of Dr.{appointment.map(row => row.cons.consultant)}
      <div style={{ display: 'flex', marginLeft: '1rem' }}>
        <form onSubmit={handleFormSubmit}>
          <button type="submit" className="btn btn-warning ms-1">
            Complete
          </button>
        </form>
        <Link to={`/cons-view/`} className="btn btn-success ms-1">
          Next
        </Link>
      </div>
    </h3>

    <div className="table-responsive">
    <table className="erp-table-modern">
        <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th>Patient ID</th>
          <th>Patient Name</th>
          <th>Gender</th>
          <th>D.O.B/Age</th>
          <th>Mobile</th>
          <th>Regd. On</th>
        </tr>
      </thead>

      <tbody>
        {appointment.map((patientData, index) => (
          <tr >
            <td>{patientData.pat.pat_id}</td>
            <td>{patientData.pat.patient}</td>
            <td>{patientData.pat.gender}</td>
            <td>{patientData.pat.age}</td>
            <td>{patientData.pat.mobile}</td>
            <td>{patientData.pat.add_date}</td>
          </tr>
        ))}
      </tbody>
    </table>
    </div>
    <nav>
      <div className="nav nav-tabs" id="nav-tab" role="tablist">
      <button className="nav-link active border-success" id="nav-case-sheet-tab" data-bs-toggle="tab"
            data-bs-target="#nav-case-sheet" type="button" role="tab" aria-controls="nav-case-sheet"
            aria-selected="true">Case Sheet</button>
     <Link to={`/emr-details/${appointment.map(row => row.pat.pat_id)}`}>
     <button className="nav-link  border-primary " id="nav-past-tab" data-bs-toggle="tab"
        data-bs-target="#nav-past" type="button" role="tab" aria-controls="nav-past"
        aria-selected="false">
            Past Visit
       </button>
       </Link>
        <button className="nav-link  border-primary " id="nav-lab-tab" data-bs-toggle="tab"
            data-bs-target="#nav-lab" type="button" role="tab" aria-controls="nav-lab"
            aria-selected="false">Lab</button>
        <button className="nav-link  border-primary " id="nav-inv-tab" data-bs-toggle="tab"
        data-bs-target="#nav-inv" type="button" role="tab" aria-controls="nav-inv"
        aria-selected="false">Radiology</button>
        <button className="nav-link  border-primary " id="nav-min-tab" data-bs-toggle="tab"
        data-bs-target="#nav-min" type="button" role="tab" aria-controls="nav-min"
        aria-selected="false">Min. Treat</button>
        <button className="nav-link  border-primary " id="nav-med-tab" data-bs-toggle="tab"
        data-bs-target="#nav-med" type="button" role="tab" aria-controls="nav-med"
        aria-selected="false">Medical Summary</button>
        <button className="nav-link  border-primary " id="nav-3d-tab" data-bs-toggle="tab"
        data-bs-target="#nav-3d" type="button" role="tab" aria-controls="nav-3d"
        aria-selected="false">Case Sheet Map</button>
      </div>
    </nav>

<div className="tab-content" id="nav-tabContent">
  <div className="tab-pane" id="nav-lab" role="tabpanel" aria-labelledby="nav-lab-tab">
  <form>
      <div className="table-responsive">
      <table className="erp-table-modern">
        <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th style={{width: 50}}>ID</th>
          <th style={{width: 270}}>Lab Test Name</th>
          <th style={{width: 70}}>Total</th>
          <th style={{width: 70}}>Action</th>
        </tr>
      </thead>

    <tbody>
    {labrows.map((row, index) => (
    <tr key={index} >
        <td>
        <input
            type="text"

            name="ltest_id"
            value={row.id}
            onChange={(e) => handlelabChange(e, index, 'id')}
            readOnly
            style={{ width: 70 }}
          />
          </td>
          <td>
            <AutoComplete

                value={row.subcat}
              options={labitems.map(item => item.subcat)}
              onChange={(event, val) => handleSelectlab(val, index)}

              onInputChange={(event, newlabInputValue) => {
                // Update input value
                setlabrows(prevlabRows => {
                  const updatedlabRows = [...prevlabRows];
                  updatedlabRows[index].subcat = newlabInputValue;
                  return updatedlabRows;
                });
              }}
             onKeyDown={e => handleKeyDownlab(e, index)}
             renderInput={(params) => (
              <div ref={params.InputProps.ref}
              >
                <input className="form-control" type="text" {...params.inputProps} focused autoFocus
                       fullWidth
                       style={{
                          width: 270,
                          background: "#F7EEFF",
                          }}
                 />
              </div>
            )}
             ref={(el) => inputlabRefs.current[index] = el}
            />
          </td>
          <td>
          <input
            type="number"

            value={row.amount}
            name="labamount"
            onChange={handlelabChange}
            onChange={(e) => handleAmountChangelab(e, index)}
            readOnly
            style={{ width: 150 }}
          />
          </td>
          <td>
          <button className="btn btn-danger" type="button" onClick={() => handleDeleteRowlab(index)}>Delete</button>
          </td>
        </tr>
      ))}
       </tbody>

        </table>
      <button className="btn btn-success addmore mt-4" type="button" onClick={handleAddRowlab}>Add More</button>
      <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}
        className='ms-5' >
            <div className="form-group" style={{display:'none'}}>
                <label style={{ fontWeight: 'bold' }}>labsubtotal: &nbsp;</label>
                <div className="input-group">
                    <div className="input-group-addon me-2 ">&#8377;</div>
                       <input type="number" value={labsubtotal} readOnly/>
                </div>
            </div>
            <div className="form-group mt-3" style={{display:'none'}}>
                <label style={{ fontWeight: 'bold' }}>Discount: &nbsp;</label>
                <div className="input-group">
                    <div className="input-group-addon me-2 ">%</div>
                       <input type="number" value={labdisPer} name="labdisPer" id="labdisPer"
                           onChange={handlelabdisPerChange} />
                </div>
            </div>
            <div className="form-group mt-3" style={{display:'none'}}>
                <label style={{ fontWeight: 'bold' }}>Discount Amount: &nbsp;</label>
                <div className="input-group">
                    <div className="input-group-addon me-2 ">&#8377;</div>
                      <input type="number" onChange={handlelabChange} name="labdisAmount" id="labdisAmount" value={labdisAmount} />
                </div>
            </div>
            <div className="form-group mt-3" style={{display:'none'}}>
                <label style={{ fontWeight: 'bold' }}>Total: &nbsp;</label>
                <div className="input-group">
                    <div className="input-group-addon me-2 ">&#8377;</div>
                        <input type="number" onChange={handlelabChange} name="labtot" value={labtotal} readOnly/>
                </div>
            </div>
          <button type="button" onClick={formSubmitlab} className="btn btn-primary mt-4">Submit</button>
        </div>
        </div>
       </form>

       <div className="row mt-4 table-responsive">
       <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
        <i className="fa-solid fa-list" aria-hidden="true" style={{color: 'red'}}></i>
       Lab Request View</h3>
       <table className="erp-table-modern">
        <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th>Appt ID</th>
          <th>Test Name</th>
          <th>Addedby</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {labview.map((labviewData, index) => (
          <tr >
            <td>{labviewData.appt_id}</td>
            <td>{labviewData.lab_test}</td>
            <td>{labviewData.addedby}</td>
            <td>
              {labviewData.lab_status == '1' ? (
                <span className="badge bg-warning">pending in cashier</span>
              ) : labviewData.lab_status == '2' ? (
                <span className="badge bg-success">Sent to Lab</span>
              ) : labviewData.lab_status == '3' ? (
                <span className="badge bg-success">View</span>
              ) : (
                <span>unknown status</span>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
    </div>
  </div>
  <div className="tab-pane" id="nav-inv" role="tabpanel" aria-labelledby="nav-inv-tab">
          <form>
      <div className="table-responsive">
          <table className="erp-table-modern">
        <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th style={{width: 50}}>ID</th>
          <th style={{width: 270}}>Inv Test Name</th>
          <th style={{width: 70}}>Total</th>
          <th style={{width: 70}}>Action</th>
        </tr>
      </thead>

      <tbody>

      {invrows.map((row, index) => (
        <tr key={index} >
        <td>
        <input
            type="text"
            name="itest_id"
            value={row.id}
            onChange={(e) => handleinvChange(e, index, 'id')}
            readOnly
            style={{width: 120}}
          />
            </td>
              <td>
                <AutoComplete
                  value={row.components}
                  options={invitems.map(item => item.components)}
                  onChange={(event, val) => handleSelectinv(val, index)}
                  onInputChange={(event, newinvInputValue) => {
                    // Update input value
                    setinvRows(previnvRows => {
                      const updatedinvRows = [...previnvRows];
                      updatedinvRows[index].components = newinvInputValue;
                      return updatedinvRows;
                    });
                  }}
                 onKeyDown={e => handleKeyDowninv(e, index)}
                 renderInput={(params) => (
                  <div ref={params.InputProps.ref}
                  >
                    <input className="form-control" type="text" {...params.inputProps} focused autoFocus
                           fullWidth
                           style={{
                              width: 270,
                              background: "#F7EEFF",
                              }}
                     />
                  </div>
                )}
                 ref={(el) => inputinvRefs.current[index] = el}
                />
              </td>
              <td>
              <input
                type="number"

                value={row.amount}
                name="invamount"
                onChange={handleinvChange}
                onChange={(e) => handleAmountChangeinv(e, index)}
                readOnly
                style={{width: 150}}
              />
              </td>
              <td>
              <button className="btn btn-danger" type="button" onClick={() => handleDeleteRowinv(index)}>Delete</button>
            </td>
        </tr>
      ))}
      </tbody>
      </table>
      <button className="btn btn-success addmore mt-4" type="button" onClick={handleAddRowinv}>Add More</button>
      <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}
        className='ms-5' >
            <div className="form-group"  style={{display:'none'}}>
                <label style={{ fontWeight: 'bold' }}>Subtotal: &nbsp;</label>
                <div className="input-group">
                    <div className="input-group-addon me-2 ">&#8377;</div>
                       <input type="number" value={invsubtotal} readOnly/>
                </div>
            </div>
            <div className="form-group mt-3" style={{display:'none'}} >
                <label style={{ fontWeight: 'bold' }}>Discount: &nbsp;</label>
                <div className="input-group">
                    <div className="input-group-addon me-2 ">%</div>
                       <input type="number" value={invdisPer} name="invdisPer" id="invdisPer"
                           onChange={handleinvDisPerChange} />
                </div>
            </div>
            <div className="form-group mt-3" style={{display:'none'}} >
                <label style={{ fontWeight: 'bold' }}>Discount Amount: &nbsp;</label>
                <div className="input-group">
                    <div className="input-group-addon me-2 ">&#8377;</div>
                      <input type="number" onChange={handleinvChange} name="invdisAmount" id="invdisAmount" value={invdisAmount} />
                </div>
            </div>
            <div className="form-group mt-3" style={{display:'none'}}>
                <label style={{ fontWeight: 'bold' }}>Total: &nbsp;</label>
                <div className="input-group">
                    <div className="input-group-addon me-2 ">&#8377;</div>
                        <input type="number" onChange={handleinvChange} name="invtot" value={invtotal} readOnly/>
                </div>
            </div>
          <button type="button" onClick={formSubmitinv} className="btn btn-primary mt-4">Submit</button>
        </div>

        </div>
       </form>

       <div className="row mt-4 table-responsive">
       <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
        <i className="fa-solid fa-list" aria-hidden="true" style={{color: 'red'}}></i>
       Radiology Request View
       </h3>
       <table className="erp-table-modern">
        <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th>Appt ID</th>
          <th>Test Name</th>
          <th>Addedby</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {invview.map((invviewData, index) => (
          <tr >
            <td>{invviewData.appt_id}</td>
            <td>{invviewData.inv_test}</td>
            <td>{invviewData.addedby}</td>
            <td>
              {invviewData.inv_status == '1' ? (
                <span className="badge bg-warning">pending in cashier</span>
              ) : invviewData.inv_status == '2' ? (
                <span className="badge bg-success">Sent to Radiology</span>
              ) : invviewData.inv_status == '3' ? (
                <span className="badge bg-success">View</span>
              ) : (
                <span>unknown status</span>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
    </div>
  </div>
  <div className="tab-pane" id="nav-min" role="tabpanel" aria-labelledby="nav-min-tab">
         <form>
      <div className="table-responsive">
          <table className="erp-table-modern">
        <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th style={{width: 50}}>ID</th>
          <th style={{width: 270}}>Min. Test Name</th>
          <th style={{width: 70}}>Total</th>
          <th style={{width: 70}}>Action</th>
        </tr>
      </thead>

      <tbody>

      {minrows.map((row, index) => (
       <tr key={index} >
        <td>
        <input
            type="text"
            name="min_id"
            value={row.id}
             onChange={(e) => handleminChange(e, index, 'id')}

            readOnly
            style={{width: 120}}
          />
          </td>
              <td>
                <AutoComplete
                   value={row.comp}
                   options={minitems.map(item => item.comp)}

                  onChange={(event, val) => handleSelectmin(val, index)}
                  onInputChange={(event, newminInputValue) => {
                    // Update input value
                    setminRows(prevminRows => {
                      const updatedminRows = [...prevminRows];
                      updatedminRows[index].comp = newminInputValue;
                      return updatedminRows;
                    });
                  }}
                 onKeyDown={e => handleKeyDownmin(e, index)}
                 renderInput={(params) => (
                  <div ref={params.InputProps.ref}
                  >
                    <input className="form-control" type="text" {...params.inputProps} focused autoFocus
                           fullWidth
                           style={{
                              width: 270,
                              background: "#F7EEFF",
                              }}
                     />
                  </div>
                )}
                 ref={(el) => inputminRefs.current[index] = el}
                />
              </td>
              <td>
          <input
            type="number"
            value={row.amount}
            name="minamount"
            onChange={handleminChange}
            onChange={(e) => handleAmountChangemin(e, index)}
            readOnly
            style={{width: 150}}
          />
          </td>
              <td>
          <button className="btn btn-danger" type="button" onClick={() => handleDeleteRowmin(index)}>Delete</button>
        </td>
        </tr>
      ))}
      </tbody>
      </table>
      <button className="btn btn-success addmore mt-4" type="button" onClick={handleAddRowmin}>Add More</button>
      <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}
        className='ms-5' >
            <div className="form-group"  style={{display:'none'}}>
                <label style={{ fontWeight: 'bold' }}>Subtotal: &nbsp;</label>
                <div className="input-group">
                    <div className="input-group-addon me-2 ">&#8377;</div>
                       <input type="number" value={minsubtotal} readOnly/>
                </div>
            </div>
            <div className="form-group mt-3" style={{display:'none'}} >
                <label style={{ fontWeight: 'bold' }}>Discount: &nbsp;</label>
                <div className="input-group">
                    <div className="input-group-addon me-2 ">%</div>
                       <input type="number" value={mindisPer} name="mindisPer" id="mindisPer"
                           onChange={handleminDisPerChange} />
                </div>
            </div>
            <div className="form-group mt-3" style={{display:'none'}} >
                <label style={{ fontWeight: 'bold' }}>Discount Amount: &nbsp;</label>
                <div className="input-group">
                    <div className="input-group-addon me-2 ">&#8377;</div>
                      <input type="number" onChange={handleminChange} name="mindisAmount" id="mindisAmount" value={mindisAmount} />
                </div>
            </div>
            <div className="form-group mt-3" style={{display:'none'}}>
                <label style={{ fontWeight: 'bold' }}>Total: &nbsp;</label>
                <div className="input-group">
                    <div className="input-group-addon me-2 ">&#8377;</div>
                        <input type="number" onChange={handleminChange} name="mintot" value={mintotal} readOnly/>
                </div>
            </div>
          <button type="button" onClick={formSubmitmin} className="btn btn-primary mt-4 ">Submit</button>
        </div>

        </div>
       </form>
  </div>
    <div className="tab-pane" id="nav-3d" role="tabpanel" aria-labelledby="nav-3d-tab">

       <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
        <i className="fa-solid fa-list" aria-hidden="true" style={{color: 'red'}}></i>
        Case Sheet Mapping
       </h3>
    <div className="table-responsive" style={{ height: '800px', overflow: 'hidden' }}>
        <Canvas className="canvas mt-5"
//        camera={{ position: [0, 0, 5], fov: 20 }}
            >
          <OrbitControls enableZoom={true} minDistance={1} maxDistance={20} />
          <ambientLight intensity={0.5} />
          <directionalLight position={[-2, 5, 2]} intensity={1} />
          <Suspense fallback={null}>
            <Anatomy onPointClick={handlePointClick} />
            {points.map(point => (
              <Marker key={point.id} point={point} onLabelChange={handleLabelChange} />
            ))}
          </Suspense>
        </Canvas>

       </div>

      <button
          type="button"
          className="btn btn-primary mt-4"
          onClick={handleSubmitD}
          disabled={!conData || conData.length === 0}
        >
          Submit
        </button>


     </div>
  <div className="tab-pane" id="nav-med" role="tabpanel" aria-labelledby="nav-med-tab">
           <div className="row mt-4">
       <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
        <i className="fa-solid fa-list" aria-hidden="true" style={{color: 'red'}}></i>
        Medical File Upload
       </h3>
       <form>
       <table className="erp-table-modern">
        <tbody>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
            <td>Type of File : </td>
            <td>
            <select name="ftype" id="ftype" value={medicalData.ftype} onChange={handleMedChange}>
            <option value="ctscan">CT-Scan</option>
            <option value="xray">X-Ray</option>
            <option value="casesheet">Case Sheet</option>
            <option value="other">Other Docs</option>
            </select>
            </td>
          </tr>
          <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
            <td>File Created Date : </td>
            <td>
             <DatePicker selected={medicalDate} onChange={handleMedDateChange} dateFormat="yyyy-MM-dd" name="date"  value={medicalData.date}/>
            </td>
          </tr>
          <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
            <td>Comments : </td>
            <td>
             <textarea className="no-comma" tabIndex={0} name="comments" id="comments"
                value={medicalData.comments}
                onChange={handleMedChange} >
             </textarea>
            </td>
          </tr>
          <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
            <td>File Upload :</td>
            <td>
          <input type="file" className="form-control" name="f_files"
            onChange={handleFileChange} id="f_files" />

          </td>
          </tr>
      </tbody>
    </table>
    <button type="button" onClick={formSubmitmed} className="btn btn-primary mt-4">Submit</button>
    </form>
    </div>
      <div className="row mt-4">
       <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
        <i className="fa-solid fa-list" aria-hidden="true" style={{color: 'red'}}></i>
       Medical Document View
       </h3>
       <div className="table-responsive">
       <table className="erp-table-modern">
        <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th>Appt ID</th>
          <th>File Type</th>
          <th>File Date</th>
          <th>Comments</th>
          <th>View</th>
          <th>Addedby</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {medview.map((medviewData, index) => (
          <tr >
            <td>{medviewData.appt.appt_id}</td>
            <td>{medviewData.file_type}</td>
            <td>{medviewData.file_date}</td>
            <td>{medviewData.comments}</td>
            <td>
            <div >
              <iframe src={medviewData.files} title={medviewData.files}
              allowfullscreen></iframe>
            </div>
            </td>
            <td>{medviewData.addedby}</td>
            <td>
            <button onClick={()=> handleDelete(medviewData.id)} className="btn btn-danger btn-sm ms-1">
            <i className="fa-solid fa-trash-can"></i></button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
    </div>
    </div>
  </div>
     <div className="tab-pane fade show active" id="nav-case-sheet" role="tabpanel" aria-labelledby="nav-case-sheet-tab">
        <form>
            <div className="row mt-4">
            <div className="col-md-2 mb-3">
                <label htmlFor="Weight" className="form-label">Weight (Kg)</label>

                <input type="number" maxLength={10} placeholder="Weight" className="form-control"
                name="weight"
                value={conData.length > 0 && conData[0].weight !== undefined ? conData[0].weight : registerFormData.weight}
                onChange={inputHandler} />
            </div>
            <div className="col-md-2 mb-3">
                <label htmlFor="Height" className="form-label">Height (cm)</label>
                <input type="number" maxLength={10} placeholder="Height" className="form-control"
                name="height"
                value={conData.length > 0 && conData[0].height !== undefined ? conData[0].height : registerFormData.height}
                onChange={inputHandler} />
            </div>
            <div className="col-md-2 mb-3">
                <label htmlFor="BMI" className="form-label">BMI</label>
                <input type="number" maxLength={10} placeholder="BMI" className="form-control"
                    name="bmi"
                    value={conData.length > 0 && conData[0].bmi !== undefined ? conData[0].bmi : registerFormData.bmi}
                    onChange={inputHandler} readOnly/>
            </div>
            <div className="col-md-2 mb-3">
                <label htmlFor="Tempr" className="form-label">Tempr.</label>
                <input type="number" maxLength={10} placeholder="Tempr" className="form-control"
                    name="tempr"
                    value={conData.length > 0 && conData[0].tempr !== undefined ? conData[0].tempr : registerFormData.tempr}
                    onChange={inputHandler} />
            </div>
            <div className="col-md-2 mb-3">
                <label htmlFor="Pulse" className="form-label">Pulse</label>
                <input type="number" maxLength={10} placeholder="Pulse" className="form-control"
                    name="pulse"
                    value={conData.length > 0 && conData[0].pulse !== undefined ? conData[0].pulse : registerFormData.pulse}
                    onChange={inputHandler} />
            </div>
            <div className="col-md-2 mb-3">
                <label htmlFor="BP(Sys/Dias)" className="form-label">BP (Sys/Dias)</label>
                <input type="text" maxLength={10} placeholder="BP(Sys/Dias)" className="form-control"
                    name="bp"
                    value={conData.length > 0 && conData[0].bp !== undefined ? conData[0].bp : registerFormData.bp}
                    onChange={inputHandler} />
            </div>
            <div className="col-md-2 mb-3">
                <label htmlFor="SPO2" className="form-label">SPO2</label>
                <input type="number" maxLength={10} placeholder="SPO2" className="form-control"
                    name="spo2"
                    value={conData.length > 0 && conData[0].spo2 !== undefined ? conData[0].spo2 : registerFormData.spo2}
                    onChange={inputHandler} />
            </div>
            <div className="col-md-2 mb-3">
                <label htmlFor="Sugar" className="form-label">Sugar</label>
                <input type="number" maxLength={10} placeholder="Sugar" className="form-control"
                    name="sugar"
                    value={conData.length > 0 && conData[0].sugar !== undefined ? conData[0].sugar : registerFormData.sugar}
                    onChange={inputHandler} />
            </div>

            </div>

            <div className="col-md-2 mb-3">
            <label htmlFor="Review" className="form-label">Review</label>
            <DatePicker selected={selectedDate || new Date()} onChange={handleDateChange} dateFormat="yyyy-MM-dd"
            value={
              conData.length > 0 && conData[0].review_date !== null
              ? conData[0].review_date
              : selectedDate !== null
              ? selectedDate.toISOString().slice(0, 10)
              : registerFormData.review_date
              }
            />
            </div>

            <div className="row">
            <div className="col-md-2 mb-3">
            <label htmlFor="Review" className="form-label">Cons.Fee Paid:</label>
            <input type="number" name="consFee" id="consFee" value={registerFormData.consFee} onChange={inputHandler} />
            </div>
            <div className="col-md-5">
            <label htmlFor="Review" className="form-label">Admission Req:</label>
            <div className="form-check form-switch">
             <input className="form-check-input" type="checkbox" name="ipStatus" id="ipStatus"
             checked={ipStatus === 1}
             onChange={handleCheckboxChange}/>
              <label className="form-check-label" htmlFor="flexSwitchCheckChecked">Yes</label>
            </div>
			</div>

  <>
    {departments == "DENTAL" ? (
<>
<div className="mt-6">
  <h4 className="font-semibold text-lg mb-3 border-b pb-1">Chief Complaint</h4>
  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mt-2 text-sm">

<div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mt-2 text-sm">
{[
      { label: 'Pain/Swelling', name: 'pain' },
      { label: 'Bad Breath', name: 'badBreath' },
      { label: 'Thyroid', name: 'thyroid' },
      { label: 'Malalign', name: 'malalign' },
      { label: 'Decay', name: 'decay' },
      { label: 'Sensitivity', name: 'sensitivity' },
      { label: 'Replacement', name: 'replacement' },
    ].map(item => (

    <label
      key={item.name}
      className="flex items-center gap-3 p-2 border rounded hover:bg-gray-50 cursor-pointer"
    >
      <input
        type="checkbox"
        name={item.name}
        className="rounded text-blue-600 w-4 h-4"
             checked={
                      conData.length > 0 && conData[0].chief_complaints
                        ? conData[0].chief_complaints.split(',').map(s => s.trim()).includes(item.name)
                        : !!medical[item.name]
                    }

          onChange={handleMedicalChange}
          className="rounded w-4 h-4 text-blue-600 focus:ring-blue-500"
        />
        <span>{item.label}</span>
    </label>
  ))}
</div>

              <div className="col-md-2 mb-3">
            <label htmlFor="Complaints" className="form-label">Complaints</label>
                <textarea className="no-comma" tabIndex={0} name="complaints" id="complaints"
                 value={transcripts.complaints || (conData.length > 0 && conData[0].complaints !== undefined ? conData[0].complaints : registerFormData.complaints)}
                 onChange={inputHandler} />
                 <button
                      className="btn btn-danger ms-4 mt-4"
                      onClick={(e) => {
                        e.preventDefault();
                        SpeechRecognition.stopListening();
                      }}
                    >
                      <i className="fa fa-microphone-lines-slash"></i>
                    </button>
                    <button
                      className="btn btn-success ms-4 mt-4"
                      onClick={(e) => {
                        e.preventDefault();
                        startListeningForField('complaints'); // <-- important: pass field name
                      }}
                    >
                      <i className="fa fa-microphone-lines"></i>
                    </button>
            </div>
  </div>
</div>
<div className="mt-6">

  <h4 className="font-semibold text-lg mb-3 border-b pb-1">Medical History</h4>
  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 mt-2 text-sm">
    {[
      { label: 'Jaundice', name: 'jaundice' },
      { label: 'High Blood Pressure', name: 'highBP' },
      { label: 'Heart Disease', name: 'heartDisease' },
      { label: 'Bleeding Disorders', name: 'bleedingDisorder' },
      { label: 'Heamophilia', name: 'heamophilia' },
      { label: 'Anaemia', name: 'anaemia' },
      { label: 'Fits', name: 'fits' },
      { label: 'Asthma / RS Problems', name: 'asthma' },
      { label: 'Thyroid', name: 'thyroid' },
      { label: 'Diabetes', name: 'diabetes' },
      { label: 'Renal Diseases', name: 'renal' },
    ].map(item => (
      <label
        key={item.name}
        className="flex items-center gap-3 p-2 border rounded hover:bg-gray-50 cursor-pointer"
      >
        <input
          type="checkbox"
          name={item.name}
             checked={
                      conData.length > 0 && conData[0].med_history
                        ? conData[0].med_history.split(',').map(s => s.trim()).includes(item.name)
                        : !!medical[item.name]
                    }

          onChange={handleMedicalChange}
          className="rounded w-4 h-4 text-blue-600 focus:ring-blue-500"
        />
        <span>{item.label}</span>
      </label>
    ))}


    <div className="col-span-1 sm:col-span-2 md:col-span-4">
      <label className="block text-sm font-medium mb-1">Are you taking any drugs now? Please specify</label>
      <input
        type="text"
        name="otherdrugs"
        value={
          conData.length > 0 && conData[0].otherdrugs !== undefined
            ? conData[0].otherdrugs
            : medical.otherdrugs
        }

        onChange={handleMedicalChange}

        className="mt-1 block w-full rounded border px-2 py-1 focus:ring-2 focus:ring-blue-300"
      />
    </div>
    <div className="col-span-1 sm:col-span-2 md:col-span-4">
      <label className="block text-sm font-medium mb-1"> Have you had any serious problems/Abnormal problems/Abnormal
      bleeding associated previous Dental / Surgery Surgery</label>
      <input
        type="text"
        name="history"
        value={
          conData.length > 0 && conData[0].history !== undefined
            ? conData[0].history
            : medical.history
        }

        onChange={handleMedicalChange}

        className="mt-1 block w-full rounded border px-2 py-1 focus:ring-2 focus:ring-blue-300"
      />
    </div>

    <div className="col-span-1 sm:col-span-2 md:col-span-4">
      <label className="block text-sm font-medium mb-1">Are you pregnant? (if female)</label>
      <input
        type="text"
        name="pregnant"
        value={
          conData.length > 0 && conData[0].ispregnant !== undefined
            ? conData[0].ispregnant
            : medical.pregnant
        }
        onChange={handleMedicalChange}
        placeholder="If yes, how many months"
        className="mt-1 block w-full rounded border px-2 py-1 focus:ring-2 focus:ring-blue-300"
      />
    </div>
  </div>
      <div className="row">
            <div className="col-md-2 mb-3">
            <label htmlFor="Allergies" className="form-label">Allergies</label>
                <textarea className="no-comma" tabIndex={0} name="allergy" id="allergy"
                 value={transcripts.allergy || (conData.length > 0 && conData[0].allergy !== undefined ? conData[0].allergy : registerFormData.allergy)}
                 onChange={inputHandler}/>
                 <button
                      className="btn btn-danger ms-4 mt-4"
                      onClick={(e) => {
                        e.preventDefault();
                        SpeechRecognition.stopListening();
                      }}
                    >
                      <i className="fa fa-microphone-lines-slash"></i>
                    </button>
                    <button
                      className="btn btn-success ms-4 mt-4"
                      onClick={(e) => {
                        e.preventDefault();
                        startListeningForField('allergy'); // <-- important: pass field name
                      }}
                    >
                      <i className="fa fa-microphone-lines"></i>
                    </button>
            </div>
            <div className="col-md-2 mb-3">
            <label htmlFor="Consulting Notes" className="form-label">General Examination</label>
                <textarea className="no-comma" tabIndex={0} name="examination" id="examination"
                value={transcripts.examination || (conData.length > 0 && conData[0].examination !== undefined ? conData[0].examination : registerFormData.examination)}
                onChange={inputHandler} />
                <button
                      className="btn btn-danger ms-4 mt-4"
                      onClick={(e) => {
                        e.preventDefault();
                        SpeechRecognition.stopListening();
                      }}
                    >
                      <i className="fa fa-microphone-lines-slash"></i>
                    </button>
                    <button
                      className="btn btn-success ms-4 mt-4"
                      onClick={(e) => {
                        e.preventDefault();
                        startListeningForField('examination'); // <-- important: pass field name
                      }}
                    >
                      <i className="fa fa-microphone-lines"></i>
                    </button>
            </div>
            <div className="col-md-2 mb-3">
            <label htmlFor="Other Illness" className="form-label">Past History</label>
                <textarea className="no-comma" tabIndex={0} name="illness" id="illness"
                value={transcripts.illness || (conData.length > 0 && conData[0].illness !== undefined ? conData[0].illness : registerFormData.illness)}
                onChange={inputHandler} />
                <button
                      className="btn btn-danger ms-4 mt-4"
                      onClick={(e) => {
                        e.preventDefault();
                        SpeechRecognition.stopListening();
                      }}
                    >
                      <i className="fa fa-microphone-lines-slash"></i>
                    </button>
                    <button
                      className="btn btn-success ms-4 mt-4"
                      onClick={(e) => {
                        e.preventDefault();
                        startListeningForField('illness'); // <-- important: pass field name
                      }}
                    >
                      <i className="fa fa-microphone-lines"></i>
                    </button>
            </div>
            <div className="col-md-2 mb-3">
            <label htmlFor="Complaints" className="form-label">Diagnosis</label>
                <textarea className="no-comma" tabIndex={0} name="diagnosis" id="diagnosis"
                 value={transcripts.diagnosis || (conData.length > 0 && conData[0].diagnosis !== undefined ? conData[0].diagnosis : registerFormData.diagnosis)}
                 onChange={inputHandler} />
                 <button
                      className="btn btn-danger ms-4 mt-4"
                      onClick={(e) => {
                        e.preventDefault();
                        SpeechRecognition.stopListening();
                      }}
                    >
                      <i className="fa fa-microphone-lines-slash"></i>
                    </button>
                    <button
                      className="btn btn-success ms-4 mt-4"
                      onClick={(e) => {
                        e.preventDefault();
                        startListeningForField('diagnosis'); // <-- important: pass field name
                      }}
                    >
                      <i className="fa fa-microphone-lines"></i>
                    </button>
            </div>
            </div>
{/* SVG Dental Chart */}
<div className="mt-6 bg-white shadow rounded p-4">
  <h4 className="font-semibold mb-3">Oral Examination(click a tooth to add notes)</h4>

  <div className="overflow-auto">
    <svg viewBox="0 0 820 420" width="100%" height="420" className="border rounded bg-gray-50">
      {/* gums */}

      <ellipse cx="410" cy="200" rx="160" ry="190" fill="#fff7f1" stroke="#f0c8b6" strokeWidth="2" />
{/* LOWER TEETH */}
{lowerTeeth.map((t, index) => (
  <g key={t.id} onClick={() => handleToothClick(t.id)} style={{ cursor: 'pointer' }}>
    <circle
      cx={t.x}
      cy={420 - t.y + 250}
      r={16}
      fill={selectedTooth.includes(t.id) ? '#fef08a' : '#ffffff'} // selection color
      stroke="#333"
      strokeWidth="1.2"
    />
    <text
      x={t.x}
      y={420 - t.y + 255}
      textAnchor="middle"
      fontSize="10"
      fill="#111"
    >
    {index < 8 ? 8 - index : index - 7}

    </text>
  </g>
))}

{/* UPPER TEETH */}
{upperTeeth.map((t, index) => (
  <g key={t.id} onClick={() => handleToothClick(t.id)} style={{ cursor: 'pointer' }}>
    <circle
      cx={t.x}
      cy={420 - (t.y + 250)}
      r={16}
      fill={selectedTooth.includes(t.id) ? '#fef08a' : '#ffffff'}
      stroke="#333"
      strokeWidth="1.2"
    />
    <text
      x={t.x}
      y={420 - (t.y + 245)}
      textAnchor="middle"
      fontSize="10"
      fill="#111"
    >
      {index < 8 ? 8 - index : index - 7}
    </text>
  </g>
))}

      {/* midline indicator */}
      <line x1="410" y1="40" x2="410" y2="380" stroke="#ddd" strokeDasharray="4 4" />
    </svg>
  </div>

<div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-6">
  <div>
  <h5 className="font-medium mb-2">Selected Teeth Notes</h5>

{selectedTooth.length ? (
  <div className="border rounded p-4 bg-gray-50 space-y-4">
    {selectedTooth.map((id) => {
      const tooth = toothData[id] || {};
      return (
        <div key={id} className="border-b pb-4">
          {/* Display label for the tooth */}
          <div className="font-semibold text-blue-700 mb-3">
            Tooth #{tooth.label || id}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* Hard Tissue */}
            <div>
              <label className="block text-sm font-medium mb-1">Hard Tissue</label>
              {hardFields.map(f => (
                <textarea
                  key={f}
                  rows={2}
                  value={tooth?.hard?.[f] || ''}
                  onChange={(e) => updateToothField(id, 'hard', f, e.target.value)}
                  placeholder={f}
                  className="mt-1 block w-full rounded border px-2 py-1 focus:ring-2 focus:ring-blue-300 text-sm mb-2"
                />
              ))}
            </div>

            {/* Soft Tissue */}
            <div>
              <label className="block text-sm font-medium mb-1">Soft Tissue</label>
              {softFields.map(f => (
                <textarea
                  key={f}
                  rows={2}
                  value={tooth?.soft?.[f] || ''}
                  onChange={(e) => updateToothField(id, 'soft', f, e.target.value)}
                  placeholder={f}
                  className="mt-1 block w-full rounded border px-2 py-1 focus:ring-2 focus:ring-blue-300 text-sm mb-2"
                />
              ))}
            </div>
          </div>
        </div>
      );
    })}
  </div>
) : (
  <div className="text-sm text-gray-500 italic">
    No teeth selected. Click any tooth above to add notes.
  </div>
)}

  </div>
{/* Legend / Teeth Notes */}
{conData.length > 0 && conData[0].teeth_notes && (
  <div className="mt-6">
    <h5 className="font-semibold mb-2">Teeth Legend</h5>
    <table className="border border-gray-300 w-full text-sm">
      <thead>
        <tr className="bg-gray-100">
          <th className="border px-2 py-1">Tooth</th>
          <th className="border px-2 py-1">Hard Tissue</th>
          <th className="border px-2 py-1">Soft Tissue</th>
        </tr>
      </thead>
      <tbody>
        {(conData[0].teeth_notes ? conData[0].teeth_notes.split(';') : []).map((toothStr, idx) => {
          if (!toothStr) return null;
          const [toothId, ...rest] = toothStr.split(':');
          const detailsStr = rest.join(':');
          const details = detailsStr.split(',');

          const hardKeys = ['Calculus','Stains','Dental Caries','Missing','Mobility'];
          const softKeys = ['Gingiva','Periodontium','Oral Mucosa'];

          const hardTissue = details
            .map(d => d.split(':'))
            .filter(([key]) => hardKeys.includes(key))
            .map(([key, value]) => value ? `${key}: ${value}` : key);

          const softTissue = details
            .map(d => d.split(':'))
            .filter(([key]) => softKeys.includes(key))
            .map(([key, value]) => value ? `${key}: ${value}` : key);

          return (
            <tr key={idx}>
              <td className="border px-2 py-1">{toothId}</td>
              <td className="border px-2 py-1">
                {hardTissue.map((item, i) => (
                  <div key={i}>{item}</div>
                ))}
              </td>
              <td className="border px-2 py-1">
                {softTissue.map((item, i) => (
                  <div key={i}>{item}</div>
                ))}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  </div>
)}

{/* Legend / Intraoral (your existing code below) */}
<div className="mt-4">
  <h6 className="font-medium mb-1">Intraoral Examination</h6>
  <div className="grid grid-cols-3 gap-2 text-sm">
    {['Good','Fair','Poor'].map(option => (
      <label key={option} className="inline-flex items-center gap-2">
        <input type="radio" name="oralHygiene" className="text-blue-600" />
        <span>{option}</span>
      </label>
    ))}
  </div>
</div>

</div>
</div>
</div>
<div className="row">
            <div className="col-md-2 mb-3">
            <label htmlFor="TreamentAdv" className="form-label">Treatment Advised</label>
                <textarea className="no-comma" tabIndex={0} name="tadvise" id="tadvise"
                 value={transcripts.tadvise || (conData.length > 0 && conData[0].tadvise !== undefined ? conData[0].tadvise : registerFormData.tadvise)}
                 onChange={inputHandler}/>
                 <button
                      className="btn btn-danger ms-4 mt-4"
                      onClick={(e) => {
                        e.preventDefault();
                        SpeechRecognition.stopListening();
                      }}
                    >
                      <i className="fa fa-microphone-lines-slash"></i>
                    </button>
                    <button
                      className="btn btn-success ms-4 mt-4"
                      onClick={(e) => {
                        e.preventDefault();
                        startListeningForField('tadvise'); // <-- important: pass field name
                      }}
                    >
                      <i className="fa fa-microphone-lines"></i>
                    </button>
            </div>
            <div className="col-md-2 mb-3">
             <label htmlFor="Symptoms" className="form-label">Symptoms</label>
              <select className="form-control"
              value={conData.length > 0 && conData[0].symptom !== undefined ? conData[0].symptom : registerFormData.symptom}
              onChange={inputHandler}
                name="symptom" id="symptoms" >
                <option value="Headache">Headache</option>
                <option value="Fever">Fever</option>
                <option value="Running Nose">Running Nose</option>
                <option value="Sore Throat">Sore Throat</option>
                <option value="Sneezing">Sneezing</option>
                <option value="Cough">Cough</option>
                <option value="Sputum">Sputum</option>
                <option value="Wheeze">Wheeze</option>
                <option value="Dyspnea">Dyspnea</option>
                <option value="PND">PND</option>
                <option value="Pedal Oedema">Pedal Oedema</option>
                <option value="Anasarca">Anasarca</option>
                <option value="Puffy Face">Puffy Face</option>
                <option value="Swelling">Swelling</option>
                <option value="Neck Swelling">Neck Swelling</option>
                <option value="Groin ">Groin </option>
                <option value="Pain">Pain</option>
                <option value="Itching">Itching</option>
                <option value="Urticaria">Urticaria</option>
                <option value="Weakness">Weakness</option>
                <option value="Vertigo">Vertigo</option>
                <option value="Unsteadiness">Unsteadiness</option>
                <option value="Chest Pain">Chest Pain</option>
                <option value="Burning Micturition">Burning Micturition</option>
                <option value="Frequency Of Urine">Frequency Of Urine</option>
                <option value="Urgency">Urgency</option>
                <option value="Diarrhea">Diarrhea</option>
                <option value="Constipation">Constipation</option>
                <option value="Bleeding PR">Bleeding PR</option>
                <option value="Epigastric Pain">Epigastric Pain</option>
                <option value="Loin Pain ">Loin Pain </option>
                <option value="Loin Pain Radiating to Rt Groin">Loin Pain Radiating to Rt Groin</option>
                <option value="Loin Pain Radiating to Lt Groin">Loin Pain Radiating to Lt Groin</option>
                <option value="LBA">LBA</option>
                <option value="LBA Radiating to Right Thigh">LBA Radiating to Rt Thigh</option>
                <option value="LBA Radiating to Left Thigh">LBA Radiating to Lt Thigh</option>
                <option value="Neck Pain">Neck Pain</option>
                <option value="Neck Pain Radiating to Right Upper Limb">Neck Pain Radiating to Rt Upper Limb</option>
                <option value="Neck Pain Radiating to Left Upper Limb">Neck Pain Radiating to Left Upper Limb</option>
              </select>
            </div>

            <div className="col-md-2 mb-3">
            <label htmlFor="Treat Sugg" className="form-label">Treatment Suggested</label>
                <textarea className="no-comma" tabIndex={0} name="tsugg" id="tsugg"
                value={transcripts.tsugg || (conData.length > 0 && conData[0].tsugg !== undefined ? conData[0].tsugg : registerFormData.tsugg)}
                onChange={inputHandler} />
                <button
                      className="btn btn-danger ms-4 mt-4"
                      onClick={(e) => {
                        e.preventDefault();
                        SpeechRecognition.stopListening();
                      }}
                    >
                      <i className="fa fa-microphone-lines-slash"></i>
                    </button>
                    <button
                      className="btn btn-success ms-4 mt-4"
                      onClick={(e) => {
                        e.preventDefault();
                        startListeningForField('tsugg'); // <-- important: pass field name
                      }}
                    >
                      <i className="fa fa-microphone-lines"></i>
                    </button>
            </div>

</div>
   </>
    ) : (
    <>
    <div className="row">
            <div className="col-md-2 mb-3">
            <label htmlFor="Allergies" className="form-label">Allergies</label>
                <textarea className="no-comma" tabIndex={0} name="allergy" id="allergy"
                 value={transcripts.allergy || (conData.length > 0 && conData[0].allergy !== undefined ? conData[0].allergy : registerFormData.allergy)}
                 onChange={inputHandler}/>
                 <button
                      className="btn btn-danger ms-4 mt-4"
                      onClick={(e) => {
                        e.preventDefault();
                        SpeechRecognition.stopListening();
                      }}
                    >
                      <i className="fa fa-microphone-lines-slash"></i>
                    </button>
                    <button
                      className="btn btn-success ms-4 mt-4"
                      onClick={(e) => {
                        e.preventDefault();
                        startListeningForField('allergy'); // <-- important: pass field name
                      }}
                    >
                      <i className="fa fa-microphone-lines"></i>
                    </button>
            </div>
            <div className="col-md-2 mb-3">
            <label htmlFor="Other Illness" className="form-label">P/H/O</label>
                <textarea className="no-comma" tabIndex={0} name="illness" id="illness"
                value={transcripts.illness || (conData.length > 0 && conData[0].illness !== undefined ? conData[0].illness : registerFormData.illness)}
                onChange={inputHandler} />
                <button
                      className="btn btn-danger ms-4 mt-4"
                      onClick={(e) => {
                        e.preventDefault();
                        SpeechRecognition.stopListening();
                      }}
                    >
                      <i className="fa fa-microphone-lines-slash"></i>
                    </button>
                    <button
                      className="btn btn-success ms-4 mt-4"
                      onClick={(e) => {
                        e.preventDefault();
                        startListeningForField('illness'); // <-- important: pass field name
                      }}
                    >
                      <i className="fa fa-microphone-lines"></i>
                    </button>
            </div>
            <div className="col-md-2 mb-3">
            <label htmlFor="Complaints" className="form-label">Complaints</label>
                <textarea className="no-comma" tabIndex={0} name="complaints" id="complaints"
                 value={transcripts.complaints || (conData.length > 0 && conData[0].complaints !== undefined ? conData[0].complaints : registerFormData.complaints)}
                 onChange={inputHandler} />
                 <button
                      className="btn btn-danger ms-4 mt-4"
                      onClick={(e) => {
                        e.preventDefault();
                        SpeechRecognition.stopListening();
                      }}
                    >
                      <i className="fa fa-microphone-lines-slash"></i>
                    </button>
                    <button
                      className="btn btn-success ms-4 mt-4"
                      onClick={(e) => {
                        e.preventDefault();
                        startListeningForField('complaints'); // <-- important: pass field name
                      }}
                    >
                      <i className="fa fa-microphone-lines"></i>
                    </button>
            </div>
            <div className="col-md-2 mb-3">
            <label htmlFor="Diagnosis" className="form-label">Diagnosis</label>
                <textarea className="no-comma" tabIndex={0} name="diagnosis" id="diagnosis"
                value={transcripts.diagnosis || (conData.length > 0 && conData[0].diagnosis !== undefined ? conData[0].diagnosis : registerFormData.diagnosis)}
                onChange={inputHandler} />
               <button
                      className="btn btn-danger ms-4 mt-4"
                      onClick={(e) => {
                        e.preventDefault();
                        SpeechRecognition.stopListening();
                      }}
                    >
                      <i className="fa fa-microphone-lines-slash"></i>
                    </button>
                    <button
                      className="btn btn-success ms-4 mt-4"
                      onClick={(e) => {
                        e.preventDefault();
                        startListeningForField('diagnosis'); // <-- important: pass field name
                      }}
                    >
                      <i className="fa fa-microphone-lines"></i>
                    </button>
            </div>
            <div className="col-md-2 mb-3">
            <label htmlFor="Dietician Notes" className="form-label">Dietician Notes</label>
                <textarea className="no-comma" tabIndex={0} name="diet" id="diet"
                value={transcripts.diet || (conData.length > 0 && conData[0].diet !== undefined ? conData[0].diet : registerFormData.diet)}
                onChange={inputHandler} />
                <button
                      className="btn btn-danger ms-4 mt-4"
                      onClick={(e) => {
                        e.preventDefault();
                        SpeechRecognition.stopListening();
                      }}
                    >
                      <i className="fa fa-microphone-lines-slash"></i>
                    </button>
                    <button
                      className="btn btn-success ms-4 mt-4"
                      onClick={(e) => {
                        e.preventDefault();
                        startListeningForField('diet'); // <-- important: pass field name
                      }}
                    >
                      <i className="fa fa-microphone-lines"></i>
                    </button>
            </div>
            <div className="col-md-2 mb-3">
            <label htmlFor="Physio Notes" className="form-label">Physio Notes</label>
                <textarea className="no-comma" tabIndex={0} name="physio" id="physio"
                value={transcripts.physio || (conData.length > 0 && conData[0].physio !== undefined ? conData[0].physio : registerFormData.physio)}
                onChange={inputHandler} />
                <button
                      className="btn btn-danger ms-4 mt-4"
                      onClick={(e) => {
                        e.preventDefault();
                        SpeechRecognition.stopListening();
                      }}
                    >
                      <i className="fa fa-microphone-lines-slash"></i>
                    </button>
                    <button
                      className="btn btn-success ms-4 mt-4"
                      onClick={(e) => {
                        e.preventDefault();
                        startListeningForField('physio'); // <-- important: pass field name
                      }}
                    >
                      <i className="fa fa-microphone-lines"></i>
                    </button>
            </div>
            </div>
            <div className="row">
            <div className="col-md-2 mb-3">
             <label htmlFor="Symptoms" className="form-label">Symptoms</label>
              <select
  className="form-control"
  name="symptom"
  id="symptoms"
  value={selectedSymptom}
  onChange={inputHandler}
>
  {symptomOptions.map(sym => (
    <option key={sym} value={sym}>{sym}</option>
  ))}
  <option value="OTHER">Other</option>
</select>
{selectedSymptom === "OTHER" && (
  <input
    type="text"
    className="form-control mt-2"
    name="other_symptom"
    placeholder="Enter symptom"
    value={
      registerFormData.other_symptom ||
      (!symptomOptions.includes(conData?.[0]?.symptom)
        ? conData?.[0]?.symptom || ""
        : "")
    }
    onChange={inputHandler}
  />
)}


            </div>
            <div className="col-md-2 mb-3">
            <label htmlFor="Consulting Notes" className="form-label">General Examination</label>
                <textarea className="no-comma" tabIndex={0} name="examination" id="examination"
                value={transcripts.examination || (conData.length > 0 && conData[0].examination !== undefined ? conData[0].examination : registerFormData.examination)}
                onChange={inputHandler} />
                <button
                      className="btn btn-danger ms-4 mt-4"
                      onClick={(e) => {
                        e.preventDefault();
                        SpeechRecognition.stopListening();
                      }}
                    >
                      <i className="fa fa-microphone-lines-slash"></i>
                    </button>
                    <button
                      className="btn btn-success ms-4 mt-4"
                      onClick={(e) => {
                        e.preventDefault();
                        startListeningForField('examination'); // <-- important: pass field name
                      }}
                    >
                      <i className="fa fa-microphone-lines"></i>
                    </button>
            </div>
            </div>
            </>
            )}
  </>
            </div>
        <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
        <i className="fa-solid fa-list" aria-hidden="true" style={{color: 'red'}}></i>
        Medicine
       </h3>
       <div className="row table-responsive">
       <table className="erp-table-modern">
  <thead>
    <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
      <th style={{width: 20}}>ID</th>
      <th style={{width: 150}}>Drug name</th>
      <th style={{width: 70}}>QTY</th>
      <th style={{width: 70}}>Intake</th>
      <th style={{width: 70}}>Remarks</th>
      <th style={{width: 70}}>Action</th>
    </tr>
  </thead>
  <tbody>
    {drugrows.map((row, index) => (
      <tr key={index}>
        <td>
          <input
            type="text"
            className="form-control"
            name="drug_id"
            tabIndex={-1}
            value={row.id}
            onChange={(e) => handledrugChange(e, index, 'id')}
            readOnly
            style={{ width: 70 }}
          />
        </td>
        <td>

          <AutoComplete
            options={drugitems}
            onChange={(event, val, id) => handleSelectdrug(val, index, id)}
            onInputChange={(event, newInputValue) => {
              setdrugrows(prevdrugRows => {
                const updateddrugRows = [...prevdrugRows];
                updateddrugRows[index].product = newInputValue;
                return updateddrugRows;
              });
            }}
            onKeyDown={e => handleKeyDowndrug(e, index)}
             getOptionLabel={(option) => option.product ? option.product.product : ''}
              renderOption={(props, option) => (
              <Box component="li" {...props}>
                {option.product ? `Product: ${option.product.product} Expy: (${option.product.expiry}) Batch: ${option.product.batch}
                Qty: ${option.qty} ` : ''}
              </Box>
            )}
            renderInput={(params) => (
              <div ref={params.InputProps.ref}>
                <input
                  className="form-control"
                  type="text"
                  label="product"
                  {...params.inputProps}
                  focused
                  autoFocus
                   variant="outlined"
                  style={{ width: 300, background: "#F7EEFF" }}
                />

              </div>
            )}
            ref={(el) => inputdrugRefs.current[index] = el}
          />
        </td>
        <td>
          <input
            type="number"
            className="form-control"
            tabIndex={0}
            value={row.dose}
            name="dose"
            onChange={(e) => handledrugChange(e, index)}
            required
            style={{ width: 130 }}
          />
        </td>
        <td>
          <select
            tabIndex={0}
            className="form-control"
            name="freq"
            onChange={(e) => handledrugChange(e, index)}
            style={{ width: 140 }}
          >
            <option value=""></option>
              <option value="After Food">After Food</option>
            <option value="Before Food">Before Food</option>
            <option value="30 Min Before Food">30 Min Before Food</option>
            <option value="15 Min Before Food">15 Min Before Food</option>
            <option value="Weekly Once">Weekly Once</option>
            <option value="Monthly Once">Monthly Once</option>
            <option value="HS">HS</option>
            <option value="HIS">HIS</option>
          </select>
        </td>
        <td>
          <select
            tabIndex={0}
            className="form-control"
            name="remarks"
            onChange={(e) => handledrugChange(e, index)}
            style={{ width: 140 }}
          >
              <option value=" ">Empty</option>
            <option value="1-0-1">1-0-1</option>
            <option value="1-1-1">1-1-1</option>
            <option value="0-1-1">0-1-1</option>
            <option value="0-1-0">0-1-0</option>
            <option value="0-0-1">0-0-1</option>
            <option value="1-0-0">1-0-0</option>
            <option value="1-1-0">1-1-0</option>
          </select>
        </td>
        <td>
          <button className="btn btn-danger" type="button" onClick={() => handleDeleteRowdrug(index)}>Delete</button>
        </td>
      </tr>
    ))}
  </tbody>
</table>
</div>
<button className="btn btn-success addmore mt-4" type="button" onClick={handleAddRowdrug}>Add More</button>

       <div className="row mt-4">
       <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
        <i className="fa-solid fa-list" aria-hidden="true" style={{color: 'red'}}></i>
       Medicine Request View</h3>
       <div className="table-responsive">
       <table className="erp-table-modern">
        <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th>Drug ID</th>
          <th>Drug Name</th>
          <th>Dose</th>
          <th>Freq</th>
          <th>Remarks</th>
          <th>Addedby</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {Array.isArray(conData) && conData.map((row) => (
          <tr key={row.id}>
            <td>{row.drug_id?.split(',').map((value, index) => <span key={index}>{value}<br /></span>)}</td>
            <td>
              {viewPharmData?.length > 0 && row.drug_id?.split(',').map((test, index) => {
                const pharmData = viewPharmData.find((data) => data.id == test);
                return (
                  <span key={index}>
                    {pharmData?.product.product}
                    <br />
                  </span>
                );
              })}
            </td>
            <td>{row.dose?.split(',').map((value, index) => <span key={index}>{value}<br /></span>)}</td>
            <td>{row.freq?.split(',').map((value, index) => <span key={index}>{value}<br /></span>)}</td>
            <td>{row.remarks?.split(',').map((value, index) => <span key={index}>{value}<br /></span>)}</td>
            <td>{row.addedby}</td>
            <td>
              {row.drug_status === '1' ? (
                <span className="badge bg-warning">Sent To Pharmacy</span>
              ) : (
                <span>unknown status</span>
              )}
            </td>
          </tr>
        ))}
      </tbody>
        </table>
        </div>
        </div>
            <div className="row">
            <div className="col-md-12 text-center mb-5">
            <button type="button" onClick={submitHandler}
            className="btn btn-success">Submit</button>
            </div>
            </div>
            </form>
        </div>
      </div>

    </section>
    )
}

export default ConsDetail;